import { Component, NgZone, OnInit } from '@angular/core';
import { bmxurl, getAccess } from 'src/globals';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AvailableTimes, AvailabilityReq, Admission, Package_returndata, Payment, Customer } from '../../PackageClasses';
import { customer } from 'src/types/customer';
import { cBookingExtras } from 'src/types/booking';
import { booking_returndata } from 'src/types/booking_returndata';
import { seriesbooking } from 'src/types/seriesbooking';
import { MessageService } from 'primeng/api';

import { cResource, resource } from 'src/types/resource';
import { v4 as uuidv4  } from 'uuid';
import { BusyService } from '../_services/busy.service';
import { admission } from 'src/types/admission';
import { paymenttypes_returndata } from 'src/types/paymenttypes_returndata';
import { bookingsummary, cBookingsummary } from 'src/types/bookingsummary';
import { DomSanitizer } from '@angular/platform-browser';
import { cDiscountvalidate, cOpenDiscountvalidate } from 'src/types/discountvailidate';
import { payment_returndata } from 'src/types/payment_returndata';
import { history_returndata } from 'src/types/history_returndata';
import { history } from 'src/types/history';
import { cRefund, refund } from 'src/types/refund';
import { ViewportScroller } from '@angular/common';
import { forkJoin } from 'rxjs';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { AuthService } from '@auth0/auth0-angular';
import { environment } from 'src/environments/environment';
import { users_returndata } from 'src/types/user_returndata';
import { birthdayanswers, questionanswers } from 'src/types/questionanswers';
import { bookingquestionitem } from 'src/types/bookingquestion';
import { emailtemplate_returndata } from 'src/types/emailtemplate_returndata';
import { bookingquestionnaire_returndata } from 'src/types/bookingquestionnaire_returndata';
import { bookingquestionnaire } from 'src/types/bookingquestionnaire';
import { GlobalService } from '../_services/global.service';
import { cVouchervalidate } from 'src/types/vouchervalidate';
import { availabletimes_returndata } from 'src/types/availabletimes_returndata';
import { packageupgrade } from 'src/types/packageupgrade';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { conf_returndata } from 'src/types/conf_returndata';
import { cPackage } from 'src/types/package';
import { get } from 'http';

@Component({
  selector: 'app-editbooking',
  templateUrl: './editbooking.component.html',
  styleUrls: ['./editbooking.component.css']
})

export class EditbookingComponent implements OnInit {

//#region Variables
  id: string;
  stateOptions: any[];
  statePayOptions: any[];
  showDiscount: boolean = false;

  PackageHeader: string = "Select a Package";
  CalendarHeader: string = "Select a Date";
  AdmissionHeader: string = "Select your Admissions";
  TimeHeader: string = "Select a Time";
  CustomerHeader: string = "Create a Customer";
  PaymentHeader: string = "Add a Payment";
  ExtrasHeader: string = "Select Extras";
  SelResourceHeader: string = "Please Select";

  packageSelected: Boolean;
  admissionsSelected: Boolean;
  dateSelected: Boolean;
  timeSelected: Boolean;
  customerSelected:Boolean;
  paymentSelected:Boolean;
  extraSelected: Boolean;
  notesSelected: Boolean;
  partyroomsSelected: Boolean;

  packageActive: Boolean;
  admissionsActive: Boolean;
  dateActive: Boolean;
  timeActive: Boolean;
  customerActive:Boolean;
  paymentActive:Boolean;
  extraActive: Boolean;
  notesActive: Boolean;
  partyroomsActive: Boolean;
  partyroomsVisible: Boolean = false;
  allowResourcesChangedManually: boolean = false;

  SelectedDate: Date;
  advancedEditStartTime: Date = null;
  advancedEditDate: Date = null;
  advancedEditSelectedTime: any = null;
  advancedEditAllTimes: any[] = [];
  advancedEditTimesLoading: boolean = false;
  advancedEditResourceSelections: { [id: string]: any } = {};
  advancedEditDateTimeExpanded: boolean = false;
  selectFromAllResources: boolean = false;
  allVenueResources: any[] = [];
  allVenueResourcesLoading: boolean = false;
  packages: any;
  SelectedPackage: any;
  searchCriteria: string;
  customersResult: any;
  ShowCustomerDetails: boolean = false;
  ShowCustomerSearch: boolean = false;

  BookingSummary: bookingsummary;
  //The other dates of a repeatable package's series, oldest first. Empty unless this booking has a
  //seriesid and the list endpoint can find them.
  seriesBookings: any[] = [];
  seriesLookupDone: boolean = false;
  //The API's record of the series this booking belongs to. Its notes are the booking's notes.
  seriesRecord: seriesbooking = null;

  VenueID: string = localStorage.getItem("SmartVenueID")!;
  NewBooking = {} as any;
  paymentLinkExpired: boolean = false;

  firstName: string = "";
  lastName: string = "";
  address1: string = "";
  address2: string = "";
  town: string = "";
  postCode: string = "";
  email: string = "";
  mobile: string = "";
  dob: Date = new Date(1900, 1, 1);

  firstNameValid: boolean = true;
  lastNameValid: boolean = true;
  Address1Valid: boolean = true;
  TownValid: boolean = true;
  PostCodeValid: boolean = true;
  EmailValid: boolean = true;
  MobileValid: boolean = true;
  EmailFormatValid: boolean = true;
  MobileFormatValid: boolean = true;

  firstNameEditValid: boolean = true;
  lastNameEditValid: boolean = true;
  Address1EditValid: boolean = true;
  TownEditValid: boolean = true;
  PostCodeEditValid: boolean = true;
  EmailEditValid: boolean = true;
  MobileEditValid: boolean = true;
  EmailFormatEditValid: boolean = true;
  MobileFormatEditValid: boolean = true;
  
  CustomerHasBeenEdited: boolean = false;

  AllValid: boolean =true;
  CustomerAllValid: boolean =true;

  ProvideMinimalPersonalData: boolean = false;
  OutstandingBalance: number;
  TotalBalance: number;
  PaymentButton: string = "Add New Payment";
  OBText:string = "";
  displayModalRefund: boolean = false;
  RefundPayment: number;
  RefundReason: string;
  RefundPaymentId: string;

  packageExtras: any[];
  paymentAmount: number;

  historyItems: history[];

  //History lines longer than this are cut short with a clickable ellipsis that opens the rest,
  //the way long package descriptions are. Rows are remembered by position in the list.
  readonly historyLimit: number = 150;
  expandedHistory = new Set<number>();

  toggleHistory(index: number)
  {
    if(this.expandedHistory.has(index))
    {
      this.expandedHistory.delete(index);
    }
    else
    {
      this.expandedHistory.add(index);
    }
  }

  disgnosticsMode: boolean = true;
  Admissions: Admission[];
  SelectedAdmissions: admission[];

  packages1: any[];
  packageExtrasNew: any[];

  RefundPaymentValid: boolean = true;
  RefundTextValid: boolean = true;
  SelectedSeletableResource: any[] = [];
  SelectedSeletableResourceBool: boolean[] = [];

  customerSelectedResources: any[] = [];
  includesComplexResources: boolean = false;
  includesOptionalResources: boolean = false;

  systemChoosesAllResources: boolean = true;

  validselection: boolean[] = [];

  SelectedResources: any[] = [];
  SelectedResourcesDisplay: any[] = [];

  paymentValueValid: boolean = true;
  paymentTypeValid: boolean = true;
  paymentValueExceededValid: boolean = true;
  paymentDepositValid: boolean = true;
  validPaymentAmount: number = 0;

  selectedPayment: any;
  PaymentTypes: any = [];

  BookingResponse: any; 
  BookingPayments: Payment[] = [];

  discountCode: string = "";

  BookingFeeAdddedOn: number = 0;
  DiscountTakenOff: number = 0;

  showPrintConfirmations: boolean = false;
  confHTML: string = "";

  TotalExtras: number = 0;
  minimumDiscount: number = 0;

  totalPayments: number;

  httpResponse: any;

  maxPayment: number;

  MinimumValidPayment:number = 0;

  totalAdmissions: number;
  PackageHasExtras: boolean;

  totalAdmissionInRange: boolean;
  ShowAdmissions: boolean = true;

  startTimes: any;
  startTimesFiltered: any;
  startTimeCheck: any;

  ShowSaveButton: boolean = false;

  activeIndex: number = 0;
  outerActiveIndex: number = 0;
  BookingResources: any[] = [];
  PossibleResources: any [] = [];

  OptionalResources:any [] = [];

  SelectedPossibleResources:any [];
  showDisableReason: Boolean = false;
  disableNotes: string = "";
  showEnableNoAvailability: boolean = false;
  showEnableReason: boolean = false;
  enableReason: string = "";

  hubConnection: HubConnection;
  private terminalPaymentResolved: boolean = false;
  private terminalPollingIntervalId: ReturnType<typeof setInterval> | null = null;
  private terminalPaymentIntentId: string = '';
  showTerminalWaiting: boolean = false;
  showTerminalBusyDialog: boolean = false;
  private pendingTerminalId: string = '';

  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;


  mustanswerallergies: boolean[] = [];
  mustanswerbirthdays: boolean[] = [];
  mustanswernumber: boolean[] = [];
  mustanswerfreetext: boolean[] = [];
  mustanswermultichoicesingleanswer: boolean[] = [];
  mustanswermultichoicemultianswer: boolean[] = [];
  mustanswerdate: boolean[] = [];

  dateAnswer: Date[] = [];

  questionAnswers: questionanswers[] = [];
  questionAnswer: questionanswers;

  bookingFreeTextAnswer: string = "";
  bookingallergyanswer: string = "";
  bookingnumberanswer: number = 0;
  bookingdateanswer: Date = null;
  allergyAnswer:boolean[] = [];
  bookingmultichoicesingleanswer: bookingquestionitem = null;
  bookingmultichoicemultianswer: bookingquestionitem[] = [];

  CurrencySymbol: string = localStorage.getItem("Currency") == null ? "GBP" : localStorage.getItem("Currency")!;

  FromEvents: boolean = false;
  SummaryItinerary: boolean = false;

  allQuestionsValid: boolean = true;

  allTasks: any[] = [];
  bookingTasks: any[] = [];

  SelectedTask: any;

  showTaskError: boolean = false; 

  EmailTemplates: any[] = [];
  selectedEmailTemplate: any;

  templateValid: boolean = true;

  paymentButtonLocked: boolean = false;

  chosenDiscountAmount: number = 0;

  stateOptionOpenDiscount: any[];
  stateOptionsNewSettings: any[];

  stateGenderOptions: any[];

  stateOptionAllergy: any[];

  openDiscount: boolean = false;
  totalDiscount: number = 0;
  startdate: string = "";

  caldays: any[] = [];
  calmonths: any[] = [];
  calyears: any[] = [];

  DOBDay: any[] = [];
  DOBMonth: any[] = [];
  DOBYear: any[] = [];

  DOBIsValid: boolean = true;
  dobage: any[] = [];
  private ageOptionCache: Map<string, any[]> = new Map<string, any[]>();


  ShowCheckButton: boolean = false;
  showVoucher: boolean = false;
  voucherCode: any;
  voucherpin: string;

  showSubscriptionlWarning: boolean = false;

  CurrentLoggedInUser: any;

  CurrentUpgrade: any;

  availablePackageUpgrades: packageupgrade[] = [];

  useNewPackageSettings: boolean = true;

  mustanswerage: boolean[] = [];
  OriginalSelectedAdmissions: any[];

  packaageAdmissionsChanged: boolean = false;

  ShowReturnToList: boolean = false;
  showReturnToSearch: boolean = false;
  ShowReturnToDaysheets: boolean;
  ShowReturnToBooking: boolean = false;
  returnToBookingFrom: string = "";

  waiverItems: any[] = [];

  showWaiversTab: boolean = false;

//#endregion 

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private messageService: MessageService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private busyService: BusyService,
    private viewportScroller: ViewportScroller,
    private auth: AuthService, private globalService: GlobalService, private ngZone: NgZone) {
      
      this.stateOptions = [{ label: 'Use full personal details', value: false }, { label: 'Use limited personal details', value: true }];      
      this.SummaryItinerary = localStorage.getItem("SummaryItineraryVenue") == "true" ? true : false;
      this.allowResourcesChangedManually = localStorage.getItem("AllowResourcesChangedManually") == "true";
      
      this.stateOptionOpenDiscount = [{ label: 'Enter Discount Value', value: true }, { label: 'Enter Discount Code', value: false}]; 
      this.stateGenderOptions =  [{ label: 'Not Stated', value: 'NOT STATED' }, { label: 'Male', value: 'MALE'}, {label: 'Female', value: 'FEMALE'}]; 
      
      this.stateOptionAllergy = [{ label: 'Yes', value: true }, { label: 'No', value: false}];  

      this.stateOptionsNewSettings = [{ label: 'Use Existing Package Settings', value: false }, { label: 'Use New Package Settings', value: true }];      

      this.dobage = [
        {name:'0 to 3 months', value:'0 to 3 months'},
        {name:'4 to 6 months', value:'4 to 6 months'},
        {name:'6 to 12 months', value:'6 to 12 months'},
        {name:'1', value:'1'},
        {name:'2', value:'2'},
        {name:'3', value:'3'},
        {name:'4', value:'4'},
        {name:'5', value:'5'},
        {name:'6', value:'6'},
        {name:'7', value:'7'},
        {name:'8', value:'8'},
        {name:'9', value:'9'},
        {name:'10', value:'10'},
        {name:'11', value:'11'},
        {name:'12', value:'12'},
        {name:'13', value:'13'},
        {name:'14', value:'14'},
        {name:'15', value:'15'},
        {name:'16', value:'16'},
        {name:'17', value:'17'},
        {name:'18', value:'18'},
        {name:'Over 18', value:'Over 18'}
      ];

      this.caldays =  [
        {name: '01', value:'01'},
        {name: '02', value:'02'},
        {name: '03', value:'03'},
        {name: '04', value:'04'},
        {name: '05', value:'05'},
        {name: '06', value:'06'},
        {name: '07', value:'07'},
        {name: '08', value:'08'},
        {name: '09', value:'09'},
        {name: '10', value:'10'},
        {name: '11', value:'11'},
        {name: '12', value:'12'},
        {name: '13', value:'13'},
        {name: '14', value:'14'},
        {name: '15', value:'15'},
        {name: '16', value:'16'},
        {name: '17', value:'17'},
        {name: '18', value:'18'},
        {name: '19', value:'19'},
        {name: '20', value:'20'},
        {name: '21', value:'21'},
        {name: '22', value:'22'},
        {name: '23', value:'23'},
        {name: '24', value:'24'},
        {name: '25', value:'25'},
        {name: '26', value:'26'},
        {name: '27', value:'27'},
        {name: '28', value:'28'},
        {name: '29', value:'29'},
        {name: '30', value:'30'},
        {name: '31', value:'31'}
      ];
          
      
      this.calmonths = [
        {name: '01', value:'01'},
        {name: '02', value:'02'},
        {name: '03', value:'03'},
        {name: '04', value:'04'},
        {name: '05', value:'05'},
        {name: '06', value:'06'},
        {name: '07', value:'07'},
        {name: '08', value:'08'},
        {name: '09', value:'09'},
        {name: '10', value:'10'},
        {name: '11', value:'11'},
        {name: '12', value:'12'}
      ];
      
      for(let i = 2050; i > 1920; i--)
      {
        let thisYear = new Date().getFullYear();
        if(i <= thisYear)
        {
          this.calyears.push({name: i.toString(), value: i.toString()});
        }
      }
  }

  // generatePDF() {
  //   const data = document.getElementById('confToPrint');

  //   html2canvas(data).then(canvas => {
  //     const imgWidth = 210;
  //     const pageHeight = 295;
  //     const imgHeight = canvas.height * imgWidth / canvas.width;
  //     const heightLeft = imgHeight;

  //     const contentDataURL = canvas.toDataURL('image/png');
  //     const pdf = new jsPDF('p', 'mm', 'a4'); 

  //     let position = 0;
  //     pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight);
  //     pdf.save('Confimation-' + this.NewBooking.bookingIdHR + new Date().toISOString() + '.pdf');
  //   });

  // }

generatePDF() {
  const data = document.getElementById('confToPrint');
  if (!data) return;

  // Wait for all images inside the element to load
  const images = Array.from(data.getElementsByTagName('img'));
  const promises = images.map(img => {
    if (img.complete) return Promise.resolve();
    return new Promise<void>(resolve => {
      img.onload = () => resolve();
      img.onerror = () => resolve();
    });
  });

  Promise.all(promises).then(() => {
    html2canvas(data, {
      useCORS: true,
      allowTaint: false,
      backgroundColor: '#fff',
      imageTimeout: 15000
    }).then(canvas => {
      const imgWidth = 210; // A4 width in mm
      const pageHeight = 295; // A4 height in mm
      const imgHeight = canvas.height * imgWidth / canvas.width;

      const contentDataURL = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');

      let position = 0;
      let heightLeft = imgHeight;

      // Add first page
      pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      // Add more pages if needed
      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      pdf.save('Confirmation-' + (this.NewBooking.bookingIdHR ?? '') + '-' + new Date().toISOString() + '.pdf');
    });
  });
}

// generatePDF() {
//   const data = document.getElementById('confToPrint');
//   if (!data) return;

//   // Wait for all images inside the element to load
//   const images = Array.from(data.getElementsByTagName('img'));
//   const promises = images.map(img => {
//     if (img.complete) return Promise.resolve();
//     return new Promise<void>(resolve => {
//       img.onload = () => resolve();
//       img.onerror = () => resolve();
//     });
//   });

//   Promise.all(promises).then(() => {
//     html2canvas(data, {
//       useCORS: true,
//       allowTaint: false,
//       backgroundColor: '#fff',
//       imageTimeout: 15000
//     }).then(canvas => {
//       const pdf = new jsPDF('p', 'mm', 'a4');
//       const imgWidth = 210; // A4 width in mm
//       const pageHeight = 295; // A4 height in mm

//       // Convert px to mm
//       const pxPerMm = canvas.width / imgWidth;
//       const imgHeight = canvas.height / pxPerMm;

//       let heightLeft = imgHeight;
//       let position = 0;

//       // For each page, slice the canvas and add to PDF
//       while (heightLeft > 0) {
//         // Calculate the slice position in px
//         const sliceTopPx = position * pxPerMm;
//         const sliceHeightPx = Math.min(pageHeight * pxPerMm, canvas.height - sliceTopPx);

//         // Create a temporary canvas for the slice
//         const pageCanvas = document.createElement('canvas');
//         pageCanvas.width = canvas.width;
//         pageCanvas.height = sliceHeightPx;
//         const pageCtx = pageCanvas.getContext('2d');
//         pageCtx.drawImage(
//           canvas,
//           0, sliceTopPx, canvas.width, sliceHeightPx,
//           0, 0, canvas.width, sliceHeightPx
//         );

//         const pageDataURL = pageCanvas.toDataURL('image/png');
//         pdf.addImage(pageDataURL, 'PNG', 0, 0, imgWidth, sliceHeightPx / pxPerMm);

//         heightLeft -= pageHeight;
//         position += pageHeight;

//         if (heightLeft > 0) pdf.addPage();
//       }

//       pdf.save('Confirmation-' + (this.NewBooking.bookingIdHR ?? '') + '-' + new Date().toISOString() + '.pdf');
//     });
//   });
// }

  displayVoucher(){
    this.showVoucher = !this.showVoucher;
  }

  saveTask()
  {
    if(this.SelectedTask != null) 
      {
        this.showTaskError = false;
        this.http.get(bmxurl + "/addtask/" + this.id + "/" + this.SelectedTask.tasktypeid).subscribe(response => {
          this.httpResponse = response;
          if(this.httpResponse.succeeded)
          {
            this.messageService.add({severity:'success', summary:'Success', detail:'Task added'});
            this.loaddata();
          }
          else
          {
            this.messageService.add({severity:'error', summary:'Failure', detail: this.httpResponse.messages[0]});
          }
        });
      }
      else
      {
        this.showTaskError = true;
      }
  }

  deleteTask(task){
    this.showTaskError = false;
        this.http.get(bmxurl + "/deletebookingtask/" + this.id + "/" + task.bookingtaskid).subscribe(response => {
          this.httpResponse = response;
          if(this.httpResponse.succeeded)
          {
            this.messageService.add({severity:'success', summary:'Success', detail:'Task removed'});
            this.loaddata();
          }
          else
          {
            this.messageService.add({severity:'error', summary:'Failure', detail: this.httpResponse.messages[0]});
          }
        });
  }

  genRandomNum()
  {
    return Math.floor((Math.random()*10000)+1).toString();
  }

  saveBookingQuestions()
  {
    let AllValid = true;

    this.NewBooking.questionnaire.bookingtoken = null;

    this.NewBooking.questionnaire.bookingquestions.forEach(question => {
      if(question.questiontype == "ALLERGY")
      {
        if(question.answers.allergyanswer.allergypresent == true)
        {
          if(question.answers.allergyanswer.allergytext == "" && question.mandatory)
          {
            AllValid = false;
            this.mustanswerallergies[question.listorder] = false;
          }
          else
          {
            this.mustanswerallergies[question.listorder] = true;
          }
        }
        else
        {
          this.mustanswerallergies[question.listorder] = true;
        }
      }
      else if(this.isPersonListQuestion(question.questiontype))
      {
        this.mustanswerbirthdays[question.listorder] = true;

        (question.answers.birthdayanswers ?? []).forEach(person => {

          if(question.showdob)
            person.birthdate = person.dobday + "/" + person.dobmonth + "/" + person.dobyear;
          else
            person.birthdate = "";

          if(question.mandatory)
          {
            //Every field the question was set up to ask for has to be answered - the extra field
            //on a register included. Read off the question rather than the saved row, so a field
            //switched on after an answer was saved is still enforced; the grid decides what to
            //show on the same basis.
            let missing = person.name == "" || person.name == null
              || ((person.age == "" || person.age == null) && question.showage)
              || ((person.birthdate == "" || person.birthdate == null) && question.showdob)
              || ((person.interests == "" || person.interests == null) && question.showinterests);

            if(missing)
            {
              AllValid = false;
              this.mustanswerbirthdays[question.listorder] = false;
            }
          }
        });
      }
      else if(question.questiontype == "NUMBER")
      {
        if(question.answers.numberanswer == null && question.mandatory)
        {
          AllValid = false;
          this.mustanswernumber[question.listorder] = false
        }
        else
        {
          this.mustanswernumber[question.listorder] = true
        }
      }
      else if(question.questiontype == "FREETEXT")
      {
        if(question.answers.freetextanswer == null && question.mandatory)
        {
          AllValid = false;
          this.mustanswerfreetext[question.listorder] = false;
        }
        else
        {
          this.mustanswerfreetext[question.listorder] = true;
        }
      }
      else if(question.questiontype == "DATE")
      {
        if(question.answers.dateanswer == null && question.mandatory)
        {
          AllValid = false;
          this.mustanswerdate[question.listorder] = false;
        }
        else
        {
          this.mustanswerdate[question.listorder] = true;
        }
      }
      else if(question.questiontype == "MULTICHOICESINGLE")
      {
        if(question.answers.multichoicesingleanswer.id == null && question.mandatory)
        {
          AllValid = false;
          this.mustanswermultichoicesingleanswer[question.listorder] = false;
        }
        else
        {
          this.mustanswermultichoicesingleanswer[question.listorder] = true;
        }

      }
      else if(question.questiontype == "MULTICHOICEMULTIPLE")
      {
        if(question.answers.multichoicemultianswer.length == 0 && question.mandatory)
        {
          AllValid = false;
          this.mustanswermultichoicemultianswer[question.listorder] = false;
        }
        else
        {
          this.mustanswermultichoicemultianswer[question.listorder] = true;
        }

      }
      else if(question.questiontype == "AGE")
      {
        if(question.answers.numberanswer == null && question.mandatory)
        {
          AllValid = false;
          this.mustanswerage[question.listorder] = false;
        }
        else
        {
          this.mustanswerage[question.listorder] = true;
        }
      }

    });
   
    if(AllValid)  
    {
      this.NewBooking.questionnaire.bookingid = this.NewBooking.bookingId;
      
      this.NewBooking.questionnaire.bookingquestions.forEach(question => {
        if(question.questiontype == "DATE")
          question.answers.dateanswer = this.dateAnswer[question.listorder];
      });

      this.http.post<booking_returndata>(bmxurl + "/questionanswers", this.NewBooking.questionnaire).subscribe(response => {
        this.httpResponse = response
        if (this.httpResponse.succeeded == true) {
          this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Your answers have been saved' });
        }
        else
        {
          this.messageService.add({ severity: 'error', summary: 'Not Added', detail:(this.httpResponse.messages[0])});
        }
      }, error => {
        this.messageService.add({ severity: 'error', summary: 'Not Added', detail: error.messages[0] });
      })
    }
  }

  //Birthday and register both ask for a list of people and keep them in the same place, so the
  //grid, the validation and the add and delete buttons are shared between them.
  isPersonListQuestion(questiontype: string): boolean {
    return questiontype == "BIRTHDAY" || questiontype == "REGISTER";
  }

  //Where an entry in the age list sits, in months. The list opens with three month bands and
  //closes with Over 18, so a plain number is only part of it.
  private ageInMonths(value: string): number {
    if(value == "0 to 3 months") return 0;
    if(value == "4 to 6 months") return 4;
    if(value == "6 to 12 months") return 6;
    if(value == "Over 18") return 228;

    const years = Number(value);
    return isNaN(years) ? 0 : years * 12;
  }

  //A birthday or register question can be set up for a range of ages, held in months. The list
  //is filtered down to that range and kept, so the dropdown is handed the same array on every
  //change detection run rather than a freshly built one.
  ageOptionsFor(question: any): any[] {
    const min = question.minage == null ? 0 : question.minage;
    const max = question.maxage == null ? 0 : question.maxage;

    if(min == 0 && max == 0)
      return this.dobage;

    const key = min + "-" + max;

    if(!this.ageOptionCache.has(key))
    {
      this.ageOptionCache.set(key, this.dobage.filter(option => {
        const months = this.ageInMonths(option.value);
        return months >= min && (max == 0 || months <= max);
      }));
    }

    return this.ageOptionCache.get(key);
  }

  //Each birthday question keeps its own list of people, so adding a row to one question leaves
  //the others alone.
  addBirthdayRow(question: any){

    if(question.answers.birthdayanswers == null)
      question.answers.birthdayanswers = [];

    question.answers.birthdayanswers.push({
      index: question.answers.birthdayanswers.length,
      id: uuidv4(),
      name: "",
      age: "",
      birthdate: "",
      gender: "",
      interests: "",
      showage: question.showage,
      showdob: question.showdob,
      showgender: question.showgender,
      showinterests: question.showinterests,
      dobday: "",
      dobmonth: "",
      dobyear: ""
    });
  }

  //Splicing inside a forEach skips the row after the one taken out, so the row is found first
  //and then removed once.
  deleteBirthdayRow(question: any, inId){

    if(question.answers.birthdayanswers == null)
      return;

    const index = question.answers.birthdayanswers.findIndex(element => element.id == inId);

    if(index > -1)
      question.answers.birthdayanswers.splice(index, 1);
  }

  ngOnInit(): void {

    this.globalService.setSmallScreenMenu(false);

    this.startdate = this.route.snapshot.paramMap.get('startdate');

    let userid = localStorage.getItem("SmartUserID");

    
    this.ShowReturnToBooking = this.route.snapshot.queryParamMap.get('returnTo') == "partybooking";
    this.returnToBookingFrom = this.route.snapshot.queryParamMap.get('from') ?? "";

    if(this.ShowReturnToBooking)
    {
        this.ShowReturnToDaysheets = false;
        this.FromEvents = false;
        this.ShowReturnToList = false;
    }
    else if(localStorage.getItem("FromDaysheet") == "TRUE")
    {
        this.ShowReturnToDaysheets = true;
        this.FromEvents = false;
        this.ShowReturnToList = false;
    }
    else
    {
        if( localStorage.getItem("FromEvents") == "TRUE")
        {
          this.FromEvents = true;
          this.ShowReturnToList = false;
          this.ShowReturnToDaysheets = false;
        }
        else
        {
          this.FromEvents = false;
          this.ShowReturnToList = true;
          this.ShowReturnToDaysheets = false;
        }
    }
        
    localStorage.removeItem("FromEvents");

      this.busyService.busy();

      this.http.get(bmxurl + "User/" + userid).subscribe(response => {
        this.httpResponse =  (response as users_returndata)
        if(this.httpResponse.succeeded)
        {
          let user = this.httpResponse.data;
          this.CurrentLoggedInUser = user;
  
          if(getAccess("MAKEABOOKING", user)){
            this.AccessAllowed = true;

            this.ProvideMinimalPersonalData = true;
        
            let qssearchparam = "";
            this.route.queryParams
              .subscribe(params => {
                qssearchparam = params.fs;
        
                if(qssearchparam == "true")
                {
                  this.showReturnToSearch = true;
                  this.ShowReturnToDaysheets = false;
                  this.FromEvents = false;
                  this.ShowReturnToList = false;
                  this.ShowReturnToBooking = false;
                }
        
              }
            );

            this.loaddata();

            this.http.get(bmxurl + "/EmailTemplateList/" + this.VenueID + "/false").subscribe(response => {
              this.httpResponse = response
              if(this.httpResponse.succeeded)
              {
                let paymentLink = localStorage.getItem("PaymentLinkEmailTemplate");
                let cancelledPaymentLink = localStorage.getItem("CancelledBookingTemplate");

                this.EmailTemplates = (response as emailtemplate_returndata).data.filter((t: any) => {
                  if (paymentLink && t.emailtemplateid === paymentLink) return false;
                  if (cancelledPaymentLink && t.emailtemplateid === cancelledPaymentLink) return false;
                  return true;
                });


              }
              else
              {
                this.messageService.add({severity:'warn', summary:'Response Message', detail: this.httpResponse.messages[0]});
              }
            }, error => {
              this.messageService.add({severity:'error', summary:'Not Saved', detail: 'Error getting Email Templates, error: ' + error.messages});
            });
        
            let qsparam = "";
            this.route.queryParams
              .subscribe(params => {
                qsparam = params.jumpto;
        
                if(qsparam == "admissions")
                {
                  this.activeIndex = 0;
                }
                else if(qsparam == "payment")
                {
                  //Tabs run Details, Customer, Upgrades, Extras, Booking Questions, Payments -
                  //so Payments is 5. This was 3, which landed on Extras. A series booking has no
                  //Payments tab, so it opens on Details.
                  this.activeIndex = this.seriesLocked ? 0 : 5;
                }
              }
            );
        
        
            this.auth.getAccessTokenSilently().subscribe(tokenReturned => {
              this.hubConnection = new HubConnectionBuilder()
              .withUrl(environment.servicestarget + "/venue/" + this.VenueID, { 
              accessTokenFactory: () => tokenReturned 
            }).build();
        
            this.hubConnection.start();
        
            this.hubConnection.on("bookingEvent", _ => {
              this.http.get(bmxurl + "booking/" + this.VenueID + "/" + this.id).subscribe(response => {
                const booking = (response as booking_returndata).data;
                this.NewBooking = booking;
                if (this.NewBooking.currency) {
                  this.CurrencySymbol = this.NewBooking.currency;
                }
                if (this.showTerminalWaiting && !this.terminalPaymentResolved && this.terminalPaymentIntentId) {
                  const matched = (booking.payments ?? []).find(
                    (p: any) => (p.PaymentId ?? p.paymentId) === this.terminalPaymentIntentId
                  );
                  if (matched) {
                    this.completeEditBookingAfterPayment(booking);
                  }
                }
              }, error => {
                this.messageService.add({severity:'error', summary:'Failure', detail:'Failed to get Booking.'});
              })
            });
        
            });
          }
  
          this.CompletedLoading = true;

          this.busyService.idle();
        }
      }, error => {
        this.busyService.idle();
        this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
      });
  }

  loaddata(){

    this.busyService.busy();

    this.id = this.route.snapshot.paramMap.get('id');
            
    if(this.id == "0")
    {
      this.messageService.add({severity:'error', summary:'Failure', detail:'Failed to get Booking.'});
      this.busyService.idle();
    }
    else
    {
      this.http.get(bmxurl + "booking/" + this.VenueID + "/" + this.id).subscribe(response => {
        
        this.NewBooking = (response as any).data;

        if (this.NewBooking.currency) {
          this.CurrencySymbol = this.NewBooking.currency;
        }

        const sentDate = this.NewBooking.paymentlinksentdate ? new Date(this.NewBooking.paymentlinksentdate) : null;
        this.paymentLinkExpired = this.NewBooking.awaitingpayment && sentDate ? (Date.now() - sentDate.getTime()) > 4 * 60 * 60 * 1000 : false;

        //A repeatable package's booking is one of several sharing a seriesid - find the others.
        this.loadSeriesBookings();

        let NewPackageObj: cPackage = {} as cPackage;

        if(this.NewBooking.questionnaire != null)
        {
          for(var i = 0; i < this.NewBooking.questionnaire.bookingquestions.length; i++)
          {
            this.mustanswerallergies[i] = true;
            this.mustanswerbirthdays[i] = true;
            this.mustanswernumber[i] = true;
            this.mustanswerfreetext[i] = true;
            this.mustanswermultichoicesingleanswer[i] = true;
            this.mustanswermultichoicemultianswer[i] = true;
            this.mustanswerdate[i] = true;
            this.allergyAnswer[i] = true;
            this.mustanswerage[i] = true;

            if(this.NewBooking.questionnaire.bookingquestions[i].answers.dateanswer != null)
              this.dateAnswer[i] = new Date(this.NewBooking.questionnaire.bookingquestions[i].answers.dateanswer)

            if(this.isPersonListQuestion(this.NewBooking.questionnaire.bookingquestions[i].questiontype))
            {
              //Each question keeps its own people. They used to be pushed into one array shared
              //by every birthday question, so two questions showed - and saved - the same list.
              this.NewBooking.questionnaire.bookingquestions[i].answers.birthdayanswers =
                (this.NewBooking.questionnaire.bookingquestions[i].answers.birthdayanswers ?? []).map(element => ({
                  index: element.index,
                  id: element.id,
                  name: element.name,
                  age: element.age,
                  birthdate: "-*-",
                  interests: element.interests,
                  gender: element.gender,
                  showage: element.showage,
                  showdob: element.showdob,
                  showgender: element.showgender,
                  showinterests: element.showinterests,
                  dobday: element.birthdate != null ? element.birthdate.split("/")[0] : "",
                  dobmonth: element.birthdate != null ? element.birthdate.split("/")[1] : "",
                  dobyear: element.birthdate != null ? element.birthdate.split("/")[2] : ""
                }));
            }
          }
        }

        if(this.NewBooking.resources != null && this.NewBooking.resources.length > 0)
          this.NewBooking.previousadmissions = JSON.parse(JSON.stringify(this.NewBooking.resources[0].admissions));

        this.bookingTasks = [];
        this.validPaymentAmount = this.NewBooking.outstanding;
        this.DiscountTakenOff = this.NewBooking.totaldiscounts;
        this.SelectedDate = new Date(this.NewBooking.startTime);
        this.advancedEditStartTime = new Date(this.NewBooking.startTime);
        this.packageExtras = this.NewBooking.extras;

        this.http.get(bmxurl + "bookingtasklist/" + this.VenueID + "/" + this.id + "/false").subscribe(response => {
          this.allTasks = (response as any).data;
        }, error => {
          this.messageService.add({severity:'error', summary:'Failure', detail:'Failed to get Tasks.'});
        });

        this.http.get(bmxurl + "TasktypeList/" + this.VenueID + "/false").subscribe(response => {
          this.bookingTasks = (response as any).data;
        });

        forkJoin({
          pkg: this.http.get(bmxurl + "package/" + this.VenueID + "/" + this.NewBooking.packageId),
          pkgList: this.http.get(bmxurl + "packagelist/" + this.VenueID + "/true")
        }).subscribe(({ pkg, pkgList }) => {

          const pkgData = (pkg as any).data as cPackage;
          NewPackageObj = {
            ...pkgData,
            startDate: new Date(pkgData.startDate),
            endDate: new Date(pkgData.endDate),
            discountstart: new Date(pkgData.discountstart),
            discountend: new Date(pkgData.discountend),
          };

          if(NewPackageObj.maxcalendarmonths == 0 || NewPackageObj.maxcalendarmonths == null)
            NewPackageObj.maxcalendarmonths = 3;

          if(NewPackageObj.bookingtimeout == 0)
            NewPackageObj.bookingtimeout = 300;

          NewPackageObj.admissions.forEach(adm => {
            adm.uselinkedadmissions = adm.linkedadmissions != null;
            adm.uselinkeddiscounts = adm.linkeddiscounts != null;
          });

          this.NewBooking.Package = NewPackageObj;
          this.OriginalSelectedAdmissions = this.NewBooking.resources[0].admissions;
          this.BookingResources = [...this.NewBooking.resources];
          this.NewBooking.resources = NewPackageObj.resources;

          this.SelectedAdmissions = [...NewPackageObj.admissions];
          this.SelectedAdmissions.forEach(SA => {
            let found = false;
            if(this.OriginalSelectedAdmissions != null && this.OriginalSelectedAdmissions != undefined)
            {
              this.OriginalSelectedAdmissions.forEach(OSA => {
                if(SA.admissionid == OSA.admissionid)
                {
                  SA.noofpeople = OSA.noofpeople;
                  found = true;
                }
              });
            }
            if(!found)
            {
              SA.noofpeople = 0;
              this.packaageAdmissionsChanged = true;
            }
          });

          this.NewBooking.resources[0].admissions = this.SelectedAdmissions;

          if(this.packaageAdmissionsChanged)
            this.messageService.add({severity:'warn', summary:'Admission Change', detail:'The Package Admissions for this booking have changed since it was made. Please review the admissions to ensure they are correct.'});

          this.packages = (pkgList as Package_returndata).data;

          let activepackages = [];
          this.packages.forEach(element => {
            if(element.disabled == false || element.packageId == this.NewBooking.packageId)
            {
              element.disabled = false;
              activepackages.push(element);
            }
          });
          this.packages = activepackages;

          this.packages.forEach(element => {
            if(element.packageId == this.NewBooking.packageId)
               this.SelectedPackage = element;
          });

          if(this.SelectedPackage)
          {
            //From the package read in full rather than from its row in the package list, which
            //does not carry the upgrades. Taking both the list and the chosen one from the same
            //place also keeps them the same objects.
            this.availablePackageUpgrades = NewPackageObj.packageupgrades ?? this.SelectedPackage.packageupgrades;

            this.setCurrentUpgradeFromBooking();

            this.packageExtrasNew = this.SelectedPackage.extras;
            this.Admissions = this.SelectedPackage.admissions;

            this.mergeExtraQuestions(this.packageExtras);

            // Use the package's own current sub-resource list for complex/group
            // resources rather than whatever was cached on it previously.
            this.SelectedPackage.resources?.forEach((pr: any) => {
              if(pr.mode === 'COMPLEX' && pr.resources != null)
              {
                pr.selectableresources = pr.resources;
              }
            });
          }
          this.TotalBalance = this.NewBooking.total;
          this.PaymentButton = "Add New Payment";

          this.setupPossibleResources();
          this.initAdvancedEdit();
          this.dosummary();
          this.setDate();
          this.setPackage();
          this.doPaymentTypes();
          this.doLinkedAdmissions();
          this.doLinkedDiscounts();
          this.getWaivers();
          this.busyService.idle();

        }, error => {
          this.busyService.idle();
          this.messageService.add({severity:'error', summary:'Failure', detail:error});
        })
      }, error => {
        this.busyService.idle();
        this.messageService.add({severity:'error', summary:'Failure', detail:'Failed to get Booking.'});
      })
    }
  }

  viewwaiver(waiver)
  {
    this.http.get(bmxurl + "Waiver/" + this.VenueID + "/" + waiver).subscribe(response => {
      this.httpResponse = response;   
      if(this.httpResponse.succeeded)
      {
        const fileURL = this.httpResponse.data.pdflink;
        window.open(fileURL, '_blank');
      }
      else
      {
        this.messageService.add({severity:'warn', summary:'Response Message', detail: this.httpResponse.messages[0]});
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Saved', detail: 'Error getting Waiver PDF, error: ' + error.messages});
    })  

  }


  //Which of the package's upgrades this booking already has, for the Upgrades dropdown.
  //
  //The upgrade flag is on the booking's own resources, and those are held in BookingResources -
  //NewBooking.resources is overwritten with the package's resource template while the booking
  //loads, so reading it here found the package's resources, which carry no upgrade. The walk is
  //recursive because a booking's resources are kept as resource groups with the resource
  //actually booked held inside, so the flag can sit a level down.
  private setCurrentUpgradeFromBooking(): void {
    const upgrades = this.availablePackageUpgrades ?? [];

    if (upgrades.length == 0) {
      return;
    }

    const flagged = this.resourcesWithUpgrade(
      (this.BookingResources != null && this.BookingResources.length > 0)
        ? this.BookingResources
        : this.NewBooking?.resources);

    flagged.forEach(res => {
      upgrades.forEach(upgrade => {
        if (upgrade.packageupgradeid == res.packageupgradeid) {
          //Taken from the same array the dropdown lists, so the two are the one object.
          this.CurrentUpgrade = upgrade;
        }
      });
    });
  }

  //Every resource on the booking marked as an upgrade, at whatever depth it is held.
  private resourcesWithUpgrade(list: any[]): any[] {
    const found: any[] = [];

    (list ?? []).forEach(res => {
      if (res.isupgrade == true) {
        found.push(res);
      }

      if (Array.isArray(res.resources) && res.resources.length > 0) {
        found.push(...this.resourcesWithUpgrade(res.resources));
      }
    });

    return found;
  }

  getWaivers()
  {
    this.http.get(bmxurl + "WaiverBookingList/" + this.VenueID + "/" + this.NewBooking.bookingId).subscribe(response => {
      this.httpResponse = response
      if(this.httpResponse.succeeded)
      {
        this.waiverItems = (response as any).data;

        if(this.SelectedPackage.waiverrequired)
        {
          this.showWaiversTab = true;
        }
        else
        {
          this.showWaiversTab = false;
        }
      }
      else
      {
        this.showWaiversTab = false;
        this.messageService.add({severity:'warn', summary:'Response Message', detail: this.httpResponse.messages[0]});
      }
    }, error => {
       this.showWaiversTab = false;
      this.messageService.add({severity:'error', summary:'Not Saved', detail: 'Error getting Waivers, error: ' + error.messages});
    })

  }

  sendEmailToBooking(){
    let canaccessmembershipss = localStorage.getItem("BetaEmailing");

    if(canaccessmembershipss != "true")
    {
      this.messageService.add({life: 7000, severity:'warn', summary:'Not Allowed', detail:"Our messaging system is in beta mode. You're invited to test it and provide feedback at support@smart-entertainment.co.uk. During the beta phase, this service is free. You can turn this on by going to settings and setting 'Try Beta Emailing' to 'Yes' in the Beta section"});
      return;
    }
    else
    {
      if(this.selectedEmailTemplate == null)
        {
          this.templateValid = false
        }
        else
        {
          this.templateValid = true;

          //A template with no placeholders goes the way it always has - the server renders it
          //from the template id alone. Only a template carrying dynamic text needs the filled
          //in content posting alongside it.
          if(!this.EmailContainsDynamicText)
          {
            this.sendBookingEmailFromTemplate();
            return;
          }

          let unfilled = this.dynamicTextArray.find((d: any) => d.text == null || d.text == "");

          if(unfilled != null)
          {
            this.messageService.add({severity:'error', summary:'Not Sent', detail:'Fill in every dynamic text area before sending.'});
            return;
          }

          let emailToSend: any = {};
          emailToSend.venueid = this.VenueID;
          emailToSend.bookingid = this.NewBooking.bookingId;
          emailToSend.templateid = this.selectedEmailTemplate.emailtemplateid;
          emailToSend.dynamicText = this.dynamicTextArray;
          emailToSend.emailsubject = this.EmailSubject;

          this.http.post<any>(bmxurl + "sendtemplatebooking", emailToSend).subscribe(response => {
            this.httpResponse = response;

            if(!this.httpResponse.succeeded)
            {
              this.messageService.add({severity:'error', summary:'Failure', detail:'An error occurred whilst trying to send the Email, error:' + this.httpResponse.messages[0]});
            }
            else
            {
              this.messageService.add({severity:'success', summary:'Success', detail: 'Email sent'});
              this.ShowDynamicTextEditor = false;
            }
          }, error => {
            this.messageService.add({severity:'error', summary:'Failure', detail:'An error occurred whilst trying to send the Email.'});
          })
        }
    }
  }

  //The original send: template id only, rendered server side.
  sendBookingEmailFromTemplate(){
    this.http.get<any>(bmxurl + "sendbookingemail/" + this.VenueID + "/" + this.NewBooking.bookingId + "/" + this.selectedEmailTemplate.emailtemplateid).subscribe(response => {
      this.httpResponse = response;

      if(!this.httpResponse.succeeded)
      {
        this.messageService.add({severity:'error', summary:'Failure', detail:'An error occurred whilst trying to send the Email, error:' + this.httpResponse.messages[0]});
      }
      else
      {
        this.messageService.add({severity:'success', summary:'Success', detail: 'Email sent'});
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Failure', detail:'An error occurred whilst trying to send the Email, error:' + error.messages[0]});
    })
  }

  sendPaymentLink(){

    this.http.get<any>(bmxurl + "sendpaymentlink/" + this.VenueID + "/" + this.NewBooking.bookingId).subscribe(response => {
      this.httpResponse = response;

      if(!this.httpResponse.succeeded)
      {
        this.messageService.add({severity:'error', summary:'Failure', detail:'An error occurred whilst trying to send the Email, error:' + this.httpResponse.messages[0]});
      }
      else
      {
        if(this.NewBooking.payments.length > 0)
        {
          this.messageService.add({severity:'success', summary:'Success', detail: 'Payment link sent'});
        }
        else
        {
          this.messageService.add({severity:'success', summary:'Success', detail: 'Payment link sent, the customer will have 4 hours to respond to this link otherwise the booking will be cancelled. Cancelled bookings cannot be paid.'});
        }
      }

    }, error => {
      this.messageService.add({severity:'error', summary:'Failure', detail:'An error occurred whilst trying to send the Email, error:' + error.messages[0]});
    })
  }

  returnToDaysheet(){

    let DateDaysheetUse = localStorage.getItem("DaysheetDate");

    localStorage.removeItem("FromDaysheet");

    this.router.navigateByUrl("/daysheetstyle1/" + DateDaysheetUse);
  }
  
  returnToSearch(){
    this.router.navigateByUrl("/search");
  }

  returnToBooking(){
    let queryParams: any = {};

    if(this.returnToBookingFrom)
    {
      queryParams.from = this.returnToBookingFrom;
    }

    this.router.navigate(["/partybooking", this.id], { queryParams: queryParams });
  }

  returnToList(){
    if(localStorage.getItem("voucherScreen") == "TRUE")
    {
      localStorage.setItem("voucherScreen", "FALSE");
      this.router.navigateByUrl("/voucherlist");
    }
    else if(localStorage.getItem("ataglance") == "TRUE")
    {
      localStorage.setItem("ataglance", "FALSE");
      let AAGData = localStorage.getItem("AAGData");
      localStorage.setItem("AAGData", "");
      this.router.navigateByUrl("/bookingblock/" + AAGData);
    }
    else if(localStorage.getItem("listScreen") == "TRUE")
    {
      localStorage.setItem("listScreen", "FALSE");
      this.router.navigateByUrl("/bookinglist");
    }
    else if(localStorage.getItem("counterBookingList") != null && localStorage.getItem("counterBookingList") != "")
    {
      let counterType = localStorage.getItem("counterBookingList");
      localStorage.removeItem("counterBookingList");
      this.router.navigateByUrl("/counterbookinglist/" + counterType);
    }
    else if(localStorage.getItem("aagBookingList") != null && localStorage.getItem("aagBookingList") != "")
    {
      let aagDate = localStorage.getItem("aagBookingList");
      localStorage.removeItem("aagBookingList");
      this.router.navigateByUrl("/ataglancebookings/" + aagDate);
    }
    else if(localStorage.getItem("homeitem") == "TRUE")
      {
        localStorage.setItem("homeitem", "FALSE");
        this.router.navigateByUrl("/homepagechoice");
      }
    else
    {
      this.router.navigateByUrl("/home/" + this.startdate);
    }
  }

  returnToEvents(){
    this.FromEvents = false;
    localStorage.removeItem("FromEvents");
    this.router.navigateByUrl("/event");
  }

  setupPossibleResources()
  {
          if (!this.SelectedPackage) return;

          //Possible Resources
          this.PossibleResources = this.SelectedPackage.resources;

          this.PossibleResources.forEach(PR => {
            if (PR.mode == 'COMPLEX')
            {

              PR.resources.forEach((innerPR: any) => {
                let index = 0;
                this.BookingResources.forEach(BR => {
                  if(index == PR.orderindex)
                  {
                    if(innerPR.id == BR.id)
                    {
                      innerPR.ignore = true; //temporarily using the ignore flag to mark these resources.
                    }
                  }
                  index++;
                });
              });

              if(PR.selectableresources != null && PR.selectableresources.length > 0)
              {
                PR.selectableresources.forEach((innerPR: any) => {
                  let index = 0;
                  this.BookingResources.forEach(BR => {
                    if(index == PR.orderindex)
                    {
                      if(innerPR.id == BR.id)
                      {
                        innerPR.ignore = true; //temporarily using the ignore flag to mark these resources.
                      }
                    }
                    index++;
                  });
                });

                if(PR.selectionmode === 'SYSTEMANY' || PR.selectionmode === 'SYSTEMLIST' || PR.selectionmode === 'ANY')
                {
                  PR.selectableresources.forEach((innerPR: any) => {
                    const matched = this.BookingResources.some((BR: any) => {
                      // Case A: container has exactly 1 resource — a specific choice was previously saved
                      if (BR.id === PR.id && BR.resources?.length === 1 && BR.resources[0].id === innerPR.id) return true;
                      // Case B: resources were exploded — each BR is an inner resource with originatingid pointing to PR
                      if (BR.originatingid === PR.id && BR.id === innerPR.id) return true;
                      // Case C: resource group — child tables carry wascontainer pointing to the group's resourceId
                      if (BR.wascontainer && BR.wascontainer === innerPR.resourceId) return true;
                      return false;
                    });
                    if(matched) { innerPR.ignore = true; }
                  });
                }
              }
            }
          });

          if(this.PossibleResources != null)
          {
            this.PossibleResources.forEach(PosRes => {
              let foundContainer = false;
              this.BookingResources.forEach(BookRes => {
                if(PosRes.id == BookRes.originatingid){
                  foundContainer = true;
                }
              });

              if(foundContainer)
                this.OptionalResources.push(true);
              else
                this.OptionalResources.push(false);

              if(PosRes.mode == "COMPLEX")
              {
                this.includesComplexResources = true;
              }
              else{
                this.includesComplexResources = false;
              }
              if(PosRes.selectionmode != "SYSTEMANY" && PosRes.selectionmode != "SYSTEMLIST")
              {
                this.systemChoosesAllResources = false;
              }
              else
              {
                this.systemChoosesAllResources = true;
              }
        
              if(PosRes.optional)
              {
                this.includesOptionalResources = true;
              }
            });
          }

          if(!this.includesComplexResources || this.systemChoosesAllResources)
          {
            this.customerSelectedResources = this.SelectedPackage.resources;
          }
      
          if(this.includesComplexResources)
          {
            this.partyroomsVisible = true;
          }
          else
          {
            this.partyroomsVisible = false;
          }
  }

  get hasEditableResources(): boolean {
    if (!this.PossibleResources?.length) return false;
    return this.PossibleResources.some(a =>
      (a.mode === 'COMPLEX' && a.selectionmode !== 'SYSTEMANY' && a.selectionmode !== 'SYSTEMLIST' && a.selectionmode !== '') ||
      (a.mode === 'COMPLEX' && a.optional && a.selectionmode === '') ||
      (this.allowResourcesChangedManually && a.mode === 'COMPLEX' && (a.selectionmode === 'SYSTEMANY' || a.selectionmode === 'SYSTEMLIST'))
    );
  }

  toggleButton(a,r){

    this.ShowCheckButton = true;
    a.selectableresources .forEach(element => {
      element.ignore = false;
    });

    a.selectableresources.forEach(element => {
      if(element.id != r.id)
      {
        element.ignore = false;
      }
      else
      {
        element.ignore = true;
      }
    });

    // this.customerSelectedResources.forEach(element => {
    //   if(element.originatingid == a.id)
    //   {
    //     a.resources.forEach(innerElement => {
    //         if(innerElement.ignore == true)
    //         {
    //           element.resources = innerElement;
    //         }
    //       });
    //   }
    // });

    this.isTimeAvailable(this.NewBooking.startTime)
  }

  showDisableMessage()
  {
    this.showDisableReason = true;
  }

  // disableBooking(){
  //   this.NewBooking.Disabled = true;

  //   this.http.put<string>(bmxurl + "/savebooking", this.NewBooking).subscribe(response => {
  //     this.BookingResponse = response 
  //     if(this.BookingResponse.succeeded)
  //     {
  //       this.NewBooking = this.BookingResponse.data.bookingObj
  //       this.messageService.add({severity:'success', summary:'Success', detail: 'The booking was disabled'});

  //       let HistoryEntry: any = {
  //         bookingid: this.NewBooking.bookingId,
  //         historyitem: "This Booking was disabled for the following reason: " + this.disableNotes
  //       }
    
  //       this.http.post<any>(bmxurl + "/History", HistoryEntry).subscribe(response => {
    
  //         if(response.succeeded)
  //         {
  //           this.disableNotes = "";
  //           this.showDisableReason = false;
  //         }
          
  //       }, error => {
  //         this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Failed to save history item' });
  //       })

  //       this.disableNotes = "";
  //       this.showDisableReason = false;

  //     }
  //     else
  //     {
  //       this.messageService.add({severity:'error', summary:'Failure', detail: 'The booking could not be disabled'});
  //     }
  //   }, error => {
  //   })
  // }

  //GET /SeriesBooking. The series keeps one set of notes for every date, so a series booking shows
  //those rather than its own.
  private loadSeriesRecord(seriesid: string)
  {
    this.http.get<any>(bmxurl + "SeriesBooking/" + this.VenueID + "/" + seriesid).subscribe(response => {
      //Sent either wrapped like the other endpoints or as the record itself.
      const record: seriesbooking = response?.data !== undefined ? response.data : response;

      //Dropped if the screen has moved on to another booking while this was on its way.
      if(this.NewBooking?.seriesid != seriesid)
      {
        return;
      }

      this.seriesRecord = (response?.succeeded === false || record == null || record.seriesid == null) ? null : record;
    }, () => {
      this.seriesRecord = null;
    });
  }

  //The notes shown for a series booking: the series' own, or this date's while the series hasn't
  //been read.
  get seriesNotes(): string
  {
    return this.seriesRecord != null ? (this.seriesRecord.notes ?? "") : (this.NewBooking?.notes ?? "");
  }

  //A repeatable package makes one booking per date, all sharing a seriesid. This endpoint returns
  //the whole series, so the only row taken out is the one being edited.
  loadSeriesBookings()
  {
    this.seriesBookings = [];
    this.seriesLookupDone = false;
    this.seriesRecord = null;

    if(this.NewBooking == null || this.NewBooking.seriesid == null || this.NewBooking.seriesid == "")
    {
      return;
    }

    this.loadSeriesRecord(this.NewBooking.seriesid);

    this.http.get<any>(bmxurl + "BookingListByseriesid/" + this.VenueID + "/" + this.NewBooking.seriesid).subscribe(response => {
      const rows = (response?.data ?? []) as any[];

      this.seriesBookings = rows
        .filter(row => row.bookingId != this.NewBooking.bookingId)
        .sort((first, second) => new Date(first.startTime).getTime() - new Date(second.startTime).getTime());

      this.seriesLookupDone = true;
    }, () => {
      this.seriesBookings = [];
      this.seriesLookupDone = true;
      this.messageService.add({severity:'error', summary:'Failure', detail:'Failed to get the other dates in this series.'});
    });
  }

  //Every date of a repeating package is booked together, so a single date can't be changed on its
  //own - the whole series has to be edited at once, and this booking is shown but not editable.
  //Taken from the seriesid alone rather than from the list of other dates, so the booking stays
  //locked even when that lookup fails.
  get seriesLocked(): boolean
  {
    return this.NewBooking?.seriesid != null && this.NewBooking.seriesid != "";
  }

  editSeries()
  {
    //The day being looked at goes with it, so Edit Series can send the user back where they came
    //from in the same way this screen does.
    const day = this.startdate != null && this.startdate != "" ? "/" + this.startdate : "";

    this.router.navigateByUrl("/editseries/" + this.NewBooking.seriesid + day);
  }

  //True once the other dates of this booking's series have been found.
  get isSeriesBooking(): boolean
  {
    return this.NewBooking?.seriesid != null && this.NewBooking.seriesid != "" && this.seriesBookings.length > 0;
  }

  //What the whole series still owes - this date plus the others.
  get seriesOutstanding(): number
  {
    const mine = Number(this.NewBooking?.outstanding) || 0;
    const others = this.seriesBookings.reduce((running, item) => running + (Number(item.outstanding) || 0), 0);

    return Math.round((mine + others) * 100) / 100;
  }

  //Puts the whole series' outstanding amount in the payment box.
  payWholeSeries()
  {
    this.validPaymentAmount = this.seriesOutstanding;
  }

  //Splits an amount across the series in proportion to what each date still owes, so the dates
  //stay evenly paid rather than one date being settled while another is left owing everything.
  //Index 0 is the date on screen, then the others in the order they are listed. Worked out in
  //pennies, with the last date taking the rounding remainder so the shares add back up exactly.
  private seriesPaymentShares(amountTaken: number): number[]
  {
    const owed = [Number(this.NewBooking.outstanding) || 0, ...this.seriesBookings.map(item => Number(item.outstanding) || 0)];
    const totals = [Number(this.NewBooking.total) || 0, ...this.seriesBookings.map(item => Number(item.total) || 0)];

    //Nothing is owed anywhere, so fall back to what each date costs.
    const owedTotal = owed.reduce((running, item) => running + item, 0);
    const shareOf = owedTotal > 0 ? owed : totals;
    const shareTotal = shareOf.reduce((running, item) => running + item, 0);

    const pennies = Math.round((Number(amountTaken) || 0) * 100);

    if(pennies <= 0)
    {
      return shareOf.map(() => 0);
    }

    if(shareTotal <= 0)
    {
      const even = Math.floor(pennies / shareOf.length);
      const evenShares = shareOf.map(() => even);
      evenShares[evenShares.length - 1] += pennies - (even * shareOf.length);
      return evenShares.map(share => share / 100);
    }

    let allocated = 0;

    const shares = shareOf.map(value => {
      const share = Math.floor((pennies * value) / shareTotal);
      allocated += share;
      return share;
    });

    shares[shares.length - 1] += pennies - allocated;

    return shares.map(share => share / 100);
  }

  //Puts the same voucher against the other dates, one at a time. The API decides how much of a
  //voucher a booking takes, so the only way to spread one is to offer it to each date in turn and
  //let it use up what is left - which means these calls cannot run at the same time, or two dates
  //would spend the same balance. Stops as soon as a date can't take any, which is what an emptied
  //voucher looks like from here; the code and PIN are known good by then, because this date has
  //already taken some.
  private applyVoucherToSeries(index: number, vouchercode: string, voucherpin: string, covered: number, done: (covered: number) => void)
  {
    if(index >= this.seriesBookings.length)
    {
      done(covered);
      return;
    }

    const sibling = this.seriesBookings[index];

    this.http.get<booking_returndata>(bmxurl + "booking/" + this.VenueID + "/" + sibling.bookingId).subscribe(response => {
      if(!response.succeeded)
      {
        done(covered);
        return;
      }

      let dv: cVouchervalidate = {
        booking: response.data,
        vouchercode: vouchercode,
        voucherpin: voucherpin
      };

      this.http.post<booking_returndata>(bmxurl + "/VoucherValidate", dv).subscribe(voucherResponse => {
        if(!voucherResponse.succeeded)
        {
          //Nothing left on the voucher, so the dates after this one get nothing either.
          done(covered);
          return;
        }

        this.applyVoucherToSeries(index + 1, vouchercode, voucherpin, covered + 1, done);
      }, () => {
        done(covered);
      });
    }, () => {
      done(covered);
    });
  }

  //Pays each of the other dates its share. The series list holds list rows rather than whole
  //bookings, so each one is fetched before its payment is added to it.
  private paySeriesSiblings(shares: number[], method: string, paymenttypeid: string, done: () => void)
  {
    const others = this.seriesBookings;

    if(shares == null || others.length == 0)
    {
      done();
      return;
    }

    this.busyService.busy();

    let waiting = others.length;
    let failed = 0;

    const finishedOne = () => {
      waiting--;

      if(waiting > 0)
      {
        return;
      }

      this.busyService.idle();

      if(failed > 0)
      {
        this.messageService.add({severity:'error', summary:'Some dates were not paid', detail: failed + (failed == 1 ? ' date' : ' dates') + ' in this series did not take their share of the payment. Check each date before taking any more money.'});
      }

      //Show what every date owes now.
      this.loadSeriesBookings();

      done();
    };

    others.forEach((sibling, index) => {
      const share = shares[index + 1] ?? 0;

      if(share <= 0)
      {
        finishedOne();
        return;
      }

      this.http.get<booking_returndata>(bmxurl + "booking/" + this.VenueID + "/" + sibling.bookingId).subscribe(response => {
        if(!response.succeeded)
        {
          failed++;
          finishedOne();
          return;
        }

        let siblingBooking: any = response.data;

        siblingBooking.inProgress = false;
        siblingBooking.payments = [{
          id: null,
          PaymentId: null,
          BookingId: siblingBooking.bookingId,
          bookingIdHR: siblingBooking.bookingIdHR,
          method: method,
          paymenttypeid: paymenttypeid,
          amount: share,
          paymentDate: new Date,
          disabled: false,
          venueid: this.VenueID,
          refunds: null,
          balance: share,
          paymenttype: "booking",
          currency: this.CurrencySymbol,
          tillname: null
        }];

        this.http.post<booking_returndata>(bmxurl + "/Payment", siblingBooking).subscribe(payResponse => {
          if(!payResponse.succeeded)
          {
            failed++;
          }

          finishedOne();
        }, () => {
          failed++;
          finishedOne();
        });
      }, () => {
        failed++;
        finishedOne();
      });
    });
  }

  //Switches this screen to another date of the series. It has to be done inside the app: opening
  //the address in a new tab loads the site from scratch and lands on the home page instead of the
  //booking. Angular keeps this component when only the booking id changes, so nothing reloads on
  //its own - the route is changed to keep the address and the Back button right, then the screen
  //is loaded again by hand. loaddata() takes the new id from the route.
  openSeriesBooking(bookingid: string)
  {
    if(bookingid == null || bookingid == this.id)
    {
      return;
    }

    this.router.navigate(['/editbooking', bookingid]).then(() => {
      this.seriesBookings = [];
      this.seriesLookupDone = false;
      this.BookingSummary = null;
      this.activeIndex = 0;
      this.outerActiveIndex = 0;

      this.loaddata();
    });
  }

  disableBooking()
  {
    this.http.delete(bmxurl + "Booking/" + this.VenueID + "/" + this.NewBooking.bookingId).subscribe(response => {
      this.BookingResponse = response
      if(this.BookingResponse.succeeded = true)
      {
        this.messageService.add({severity:'success', summary:'Disabled', detail:'Booking successfully disabled'});
        
        this.NewBooking.disabled = true;

        let HistoryEntry: any = {
          bookingid: this.NewBooking.bookingId,
          historyitem: "This Booking was disabled for the following reason: " + this.disableNotes
        }
    
        this.http.post<any>(bmxurl + "/History", HistoryEntry).subscribe(response => {
    
          if(response.succeeded)
          {
            this.disableNotes = "";
            this.showDisableReason = false;

            this.loaddata();
          }
          
        }, error => {
          this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Failed to save history item' });
        })

        this.disableNotes = "";
        this.showDisableReason = false;
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Disabled', detail: 'An error occurred disabling this Booking'});
    })
}

  enableBooking() {
    if (!this.SelectedPackage || !this.SelectedAdmissions) {
      this.doEnableBooking();
      return;
    }

    this.busyService.busy();

    let totalNoOfPeople: number = 0;
    const req = {} as AvailabilityReq;
    req.Admissions = [] as admission[];
    this.SelectedAdmissions.forEach(adm => {
      req.Admissions.push(adm);
      totalNoOfPeople += adm.noofpeople;
    });
    req.packageId = this.SelectedPackage.packageId;
    req.NoOfPeople = totalNoOfPeople;
    req.venueid = this.VenueID;
    req.StartTime = this.SelectedDate.getFullYear() + "-" + (this.SelectedDate.getMonth() + 1) + "-" + this.SelectedDate.getDate() + "T00:00:00.000Z";
    req.DiagnosticMode = false;
    req.IgnoreExistingBooking = true;
    req.ExistingBookingID = this.NewBooking.bookingId;
    req.Resources = this.NewBooking.resources;

    this.http.post<availabletimes_returndata>(bmxurl + "/Availability", req).subscribe(response => {
      const times: any = (response as availabletimes_returndata).data;
      let found = false;

      if (times != null && times.length > 0) {
        times.forEach(element => {
          const elementTime = ('00' + new Date(element.time).getHours()).slice(-2) + ":" + ('00' + new Date(element.time).getMinutes()).slice(-2);
          const chosenTime = ('00' + new Date(this.NewBooking.startTime).getHours()).slice(-2) + ":" + ('00' + new Date(this.NewBooking.startTime).getMinutes()).slice(-2);
          if (elementTime == chosenTime && element.timeAvailable) {
            found = true;
          }
        });
      }

      this.busyService.idle();

      if (found) {
        this.doEnableBooking();
      } else {
        this.showEnableNoAvailability = true;
      }
    }, error => {
      this.busyService.idle();
      this.doEnableBooking();
    });
  }

  confirmEnableAnyway() {
    this.showEnableNoAvailability = false;
    this.showEnableReason = true;
  }

  doEnableWithReason() {
    const reason = this.enableReason;
    this.showEnableReason = false;
    this.enableReason = "";
    this.doEnableBooking(reason);
  }

  doEnableBooking(reason?: string) {
    this.NewBooking.Disabled = false;
    this.NewBooking.salestype = 0;

    this.busyService.busy();

    this.http.put<string>(bmxurl + "/savebooking/true", this.NewBooking).subscribe(response => {
      this.BookingResponse = response;

      if (this.BookingResponse.succeeded) {
        this.NewBooking = this.BookingResponse.data.bookingObj;
        this.messageService.add({severity: 'success', summary: 'Success', detail: 'The booking was re-enabled'});

        if (reason) {
          const historyEntry: any = {
            bookingid: this.NewBooking.bookingId,
            historyitem: "This booking was re-enabled despite no availability for the following reason: " + reason
          };
          this.http.post<any>(bmxurl + "/History", historyEntry).subscribe(_ => {}, error => {
            this.messageService.add({severity: 'error', summary: 'Failed', detail: 'Failed to save history item'});
          });
        }

        this.busyService.idle();
        this.loaddata();
      } else {
        this.busyService.idle();
        this.messageService.add({severity: 'error', summary: 'Failure', detail: 'The booking could not be re-enabled'});
      }
    }, error => {
      this.busyService.idle();
    });
  }

  checkTab()
  {
    //A series booking has no Payments tab, so everything after it is one place earlier.
    const historyIndex = (this.showWaiversTab ? 7 : 6) - (this.seriesLocked ? 1 : 0);
    if(this.activeIndex == historyIndex)
    {
      this.dohistory();
    }
  }

  saveAdvancedEdit() {
    if (!this.advancedEditDate) {
      this.messageService.add({severity: 'warn', summary: 'Missing Date', detail: 'Please select a date.'});
      return;
    }
    if (!this.advancedEditSelectedTime?.time) {
      this.messageService.add({severity: 'warn', summary: 'Missing Time', detail: 'Please select a time.'});
      return;
    }

    const missingResource = this.PossibleResources?.find((pr: any) =>
      pr.mode === 'COMPLEX' &&
      ((pr.selectionmode === 'SYSTEMANY' || pr.selectionmode === 'SYSTEMLIST') || this.selectFromAllResources) &&
      !this.advancedEditResourceSelections[pr.id]
    );
    if (missingResource) {
      this.messageService.add({severity: 'warn', summary: 'Resource Required', detail: `Please select a resource for "${missingResource.name}".`});
      return;
    }

    this.NewBooking.startTime = this.advancedEditSelectedTime.time;
    this.NewBooking.resources = this.advancedEditSelectedTime.resources || this.BookingResources;

    // Apply any manual resource overrides into the timeslot resource array
    const hasOverrides = this.PossibleResources?.some((pr: any) =>
      pr.mode === 'COMPLEX' &&
      (pr.selectionmode === 'SYSTEMANY' || pr.selectionmode === 'SYSTEMLIST') &&
      this.advancedEditResourceSelections[pr.id]
    );
    if (hasOverrides) {
      let resources = [...this.NewBooking.resources];
      this.PossibleResources.forEach((pr: any) => {
        if (pr.mode !== 'COMPLEX') return;
        if (pr.selectionmode !== 'SYSTEMANY' && pr.selectionmode !== 'SYSTEMLIST') return;
        const selected = this.advancedEditResourceSelections[pr.id];
        if (!selected) return;

        // Predicate matching all booking resource entries that belong to this package resource group
        const isForThisGroup = (r: any) =>
          r.id === pr.id ||
          r.originatingid === pr.id ||
          (r.wascontainer && pr.selectableresources?.some((sr: any) => sr.resourceId === r.wascontainer)) ||
          // Case D: backward compat — resource previously saved with wascontainer:null, match by resourceId
          (!r.wascontainer && !r.originatingid && r.id !== pr.id &&
           pr.selectableresources?.some((sr: any) => sr.resourceId === r.resourceId));

        const firstIdx = resources.findIndex(isForThisGroup);
        if (firstIdx < 0) return;

        let replacements: any[];
        const subResources = selected.resources ?? [];

        if (selected.isresourcecontainer && subResources.length > 0) {
          // Container resource: explode sub-resources with wascontainer pointing back to selected
          const containerId = selected.resourceId || selected.ResourceId;
          const bookingStart = new Date(this.NewBooking.startTime);
          const lengthMins: number = pr.length;
          //Sub-resources come from the package definition and carry no booking admissions,
          //so without this the explode silently replaces them with empty arrays. Carried
          //onto the first replacement only - spreading them across all N would multiply the
          //booking's admissions, and the rest of this screen treats resources[0] as the holder.
          const carriedAdmissions = this.admissionsForGroup(resources[firstIdx], isForThisGroup);
          replacements = subResources.map((sr: any, srIndex: number) => {
            const offsetMins: number = sr.startTimeOffset ?? pr.startTimeOffset ?? 0;
            const startTime = new Date(bookingStart.getTime() + offsetMins * 60000);
            const endTime = new Date(startTime.getTime() + lengthMins * 60000);
            return {
              ...sr,
              wascontainer: containerId,
              mode: pr.mode,
              length: lengthMins,
              bookingId: this.NewBooking.bookingId,
              startTime: startTime.toISOString(),
              endTime: endTime.toISOString(),
              admissions: (sr.admissions != null && sr.admissions.length > 0)
                ? sr.admissions
                : (srIndex === 0 ? carriedAdmissions : []),
              tags: sr.tags ?? [],
              classes: (sr.classes ?? []).map((c: any) => ({ ...c, adjustments: c.adjustments ?? [] }))
            };
          });
        } else {
          // Non-container: determine current storage format from first matching entry
          const firstMatch = resources[firstIdx];
          let replacement: any;
          if (firstMatch.id === pr.id) {
            // Case A: outer container wrapper — keep wrapper, replace inner resource
            replacement = { ...firstMatch, resources: [selected] };
          } else if (firstMatch.originatingid === pr.id) {
            // Case B: new resource identity from selected, booking-specific fields from firstMatch
            replacement = {
              ...selected,
              id: firstMatch.id,
              originatingid: pr.id,
              mode: firstMatch.mode,
              length: firstMatch.length,
              bookingId: firstMatch.bookingId,
              startTime: firstMatch.startTime,
              endTime: firstMatch.endTime,
              admissions: (selected.admissions ?? firstMatch.admissions) ?? [],
              tags: (selected.tags ?? firstMatch.tags) ?? [],
              classes: ((selected.classes ?? firstMatch.classes) ?? []).map((c: any) => ({ ...c, adjustments: c.adjustments ?? [] }))
            };
          } else {
            // Case C: new resource identity from selected, booking-specific fields from firstMatch
            replacement = {
              ...selected,
              id: firstMatch.id,
              wascontainer: selected.resourceId || selected.ResourceId,
              mode: firstMatch.mode,
              length: firstMatch.length,
              bookingId: firstMatch.bookingId,
              startTime: firstMatch.startTime,
              endTime: firstMatch.endTime,
              admissions: (selected.admissions ?? firstMatch.admissions) ?? [],
              tags: (selected.tags ?? firstMatch.tags) ?? [],
              classes: ((selected.classes ?? firstMatch.classes) ?? []).map((c: any) => ({ ...c, adjustments: c.adjustments ?? [] }))
            };
          }
          replacements = [replacement];
        }

        // Remove all entries for this group, insert replacement(s) at the original position
        const insertAt = resources.slice(0, firstIdx).filter((r: any) => !isForThisGroup(r)).length;
        const without = resources.filter((r: any) => !isForThisGroup(r));
        resources = [...without.slice(0, insertAt), ...replacements, ...without.slice(insertAt)];
      });
      this.NewBooking.resources = resources;
    }

    //Checked after the resource rebuild above, since that is what can drop the admissions.
    if (!this.bookingHasAdmissions(this.NewBooking)) {
      this.abandonSaveAndReload(false);
      return;
    }

    this.busyService.busy();

    this.http.put<any>(bmxurl + "/savebooking/true", this.NewBooking).subscribe(response => {
      this.httpResponse = response;
      this.busyService.idle();
      if (this.httpResponse.succeeded) {
        this.outerActiveIndex = 0;
        this.messageService.add({severity: 'success', summary: 'Saved', detail: 'Booking updated successfully.'});
        this.loaddata();
      } else {
        this.messageService.add({severity: 'error', summary: 'Failed', detail: this.httpResponse.messages[0]});
      }
    }, error => {
      this.busyService.idle();
      this.messageService.add({severity: 'error', summary: 'Error', detail: 'Failed to save booking.'});
    });
  }

  initAdvancedEdit() {
    const st = new Date(this.NewBooking.startTime);
    this.advancedEditDate = new Date(st.getFullYear(), st.getMonth(), st.getDate());
    this.advancedEditSelectedTime = { time: this.NewBooking.startTime };
    this.advancedEditAllTimes = [];
    this.initAdvancedEditResources();
  }

  toggleAdvancedEditDateTime() {
    this.advancedEditDateTimeExpanded = !this.advancedEditDateTimeExpanded;

    if (this.advancedEditDateTimeExpanded && this.advancedEditAllTimes.length === 0 && !this.advancedEditTimesLoading) {
      this.getAdvancedEditTimes();
    }
  }

  getAdvancedEditTimes() {
    if (!this.advancedEditDate || !this.SelectedPackage) return;

    this.advancedEditAllTimes = [];
    this.advancedEditTimesLoading = true;

    const d = this.advancedEditDate;
    const req = {} as AvailabilityReq;
    req.Admissions = [];
    let totalNoOfPeople = 0;
    if (this.SelectedAdmissions) {
      this.SelectedAdmissions.forEach((adm: any) => {
        req.Admissions.push(adm);
        totalNoOfPeople += adm.noofpeople;
      });
    }
    req.packageId = this.SelectedPackage.packageId;
    req.NoOfPeople = totalNoOfPeople;
    req.venueid = this.VenueID;
    req.StartTime = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + 'T00:00:00.000Z';
    req.DiagnosticMode = false;
    req.IgnoreExistingBooking = true;
    req.ExistingBookingID = this.NewBooking.bookingId;
    req.Resources = this.NewBooking.resources;

    this.http.post<availabletimes_returndata>(bmxurl + '/Availability', req).subscribe(response => {
      this.advancedEditTimesLoading = false;
      if ((response as availabletimes_returndata).succeeded) {
        const allTimes: any[] = (response as availabletimes_returndata).data || [];
        const seen = new Set<string>();
        this.advancedEditAllTimes = allTimes.filter(t => {
          if (!t.primaryResource) return false;
          if (seen.has(t.time)) return false;
          seen.add(t.time);
          return true;
        });
      }
    }, () => {
      this.advancedEditTimesLoading = false;
    });
  }

  initAdvancedEditResources() {
    this.advancedEditResourceSelections = {};
    if (!this.PossibleResources) return;

    this.PossibleResources.forEach((pr: any) => {
      if (pr.mode !== 'COMPLEX') return;
      if (pr.selectionmode !== 'SYSTEMANY' && pr.selectionmode !== 'SYSTEMLIST') return;
      if (!pr.selectableresources?.length) return;

      // Mirror the three matching cases used in setupPossibleResources
      const matched = pr.selectableresources.find((sr: any) =>
        this.BookingResources.some((br: any) => {
          // Container with single inner resource
          if (br.id === pr.id && br.resources?.length === 1 && br.resources[0].id === sr.id) return true;
          // Exploded: booking resource has originatingid pointing to the container
          if (br.originatingid === pr.id && br.id === sr.id) return true;
          // wascontainer
          if (br.wascontainer && br.wascontainer === sr.resourceId) return true;
          // Case D: backward compat — resource previously saved with wascontainer:null, match by resourceId
          if (!br.wascontainer && !br.originatingid && br.id !== pr.id && br.resourceId === sr.resourceId) return true;
          return false;
        })
      );

      if (matched) {
        this.advancedEditResourceSelections[pr.id] = matched;
      }
    });
  }

  get hasAdvancedEditResources(): boolean {
    return this.PossibleResources?.some((pr: any) =>
      pr.mode === 'COMPLEX' && (pr.selectionmode === 'SYSTEMANY' || pr.selectionmode === 'SYSTEMLIST')
    ) ?? false;
  }

  get hasAnyComplexResources(): boolean {
    return this.PossibleResources?.some((pr: any) => pr.mode === 'COMPLEX') ?? false;
  }

  onSelectFromAllResourcesChange() {
    if (!this.selectFromAllResources) return;
    if (this.allVenueResources.length > 0) return;
    this.allVenueResourcesLoading = true;
    this.http.get<any>(bmxurl + 'ResourceList/' + this.VenueID + '//false').subscribe(response => {
      this.allVenueResourcesLoading = false;
      if (response?.succeeded) {
        this.allVenueResources = (response.data ?? []).sort((a: any, b: any) => a.name.localeCompare(b.name));
      }
    }, () => {
      this.allVenueResourcesLoading = false;
    });
  }

  displayDiscount(){
    this.showDiscount = !this.showDiscount;
  }

  doneVoucher()
  {  
    this.busyService.busy();

    let newCustomer: any;

    newCustomer = this.NewBooking.customer;
    
    let dv: cVouchervalidate = {
      booking: this.NewBooking,
      vouchercode: this.voucherCode.trim(),
      voucherpin : this.voucherpin.trim()
    }

    this.http.post<booking_returndata>(bmxurl + "/VoucherValidate", dv).subscribe(response => {
      this.httpResponse = response
      if (this.httpResponse.succeeded == true) {
        this.messageService.add({ severity: 'success', summary: 'Voucher Added', detail: 'Your voucher has been added' });

        this.showVoucher = false;
        this.voucherCode = "";

        this.NewBooking = (response as booking_returndata).data;

        this.BookingPayments = this.NewBooking.payments;
        this.NewBooking.totaladmissions = this.NewBooking.totaladmission;

        this.validPaymentAmount = this.NewBooking.outstanding;

        this.totalPayments = 0;
        this.BookingPayments.forEach(element => {
          this.totalPayments += element.amount;
        });

        this.selectedPayment = null;

        this.dosummary();

        //Whatever is left of the voucher goes on the other dates of the series.
        if(this.isSeriesBooking)
        {
          const dateCount = this.seriesBookings.length + 1;

          this.applyVoucherToSeries(0, dv.vouchercode, dv.voucherpin, 1, covered => {
            this.messageService.add({
              severity: covered == dateCount ? 'success' : 'warn',
              summary: 'Voucher spread across the series',
              detail: covered == dateCount
                ? 'The voucher was put against all ' + dateCount + ' dates.'
                : 'The voucher covered ' + covered + ' of ' + dateCount + ' dates before it ran out.'});

            //Show what each date owes now.
            this.loadSeriesBookings();
            this.busyService.idle();
          });

          return;
        }

        this.busyService.idle();

      }
      else
      {
        this.busyService.idle();
        this.messageService.add({ severity: 'error', summary: 'Not Added', detail:(this.httpResponse.messages[0])});
      }
    }, error => {
      this.busyService.idle();
      this.messageService.add({ severity: 'error', summary: 'Not Added', detail: error.error.messages[0] });
    })
  }

  doneDiscount(){
    //send discount to server
    let dv: cDiscountvalidate = {
      booking: this.NewBooking,
      discountcode: this.discountCode
    }

    this.http.post<booking_returndata>(bmxurl + "/DiscountValidate", dv).subscribe(response => {
      this.httpResponse = response
      if (this.httpResponse.succeeded == true) {
        this.messageService.add({ severity: 'success', summary: 'Discount Added', detail: 'Your discount has been added' });

        this.http.get(bmxurl + "TasktypeList/" + this.VenueID + "/false").subscribe(response => {
          this.bookingTasks = (response as any).data;
        });

        this.showDiscount = false;
        this.discountCode = "";

        this.NewBooking = (response as booking_returndata).data;
        this.DiscountTakenOff = this.NewBooking.totaldiscounts;
        this.NewBooking.totaladmissions = (response as booking_returndata).data.totaladmission;

        //this.CalcDeposit(this.BookingResponse.bookingObj.total);
        this.NewBooking.totalvenuedeposit = (response as booking_returndata).data.totalvenuedeposit;
        this.NewBooking.totalpublicdeposit  = (response as booking_returndata).data.totalpublicdeposit ;

        this.validPaymentAmount = this.NewBooking.outstanding;

        this.dosummary();
      }
      else
      {
        this.messageService.add({ severity: 'error', summary: 'Not Added', detail:(this.httpResponse.messages[0])});
      }
    }, error => {
      this.messageService.add({ severity: 'error', summary: 'Not Added', detail: error.messages[0] });
    })
  }

  doneOpenDiscount(){
    //send discount to server
    let dv: cOpenDiscountvalidate = {
      booking: this.NewBooking,
      value : this.chosenDiscountAmount
    }

    this.http.post<booking_returndata>(bmxurl + "/opendiscount", dv).subscribe(response => {
      this.httpResponse = response
      if (this.httpResponse.succeeded == true) {
        this.messageService.add({ severity: 'success', summary: 'Discount Added', detail: 'Your discount has been added' });

        this.http.get(bmxurl + "TasktypeList/" + this.VenueID + "/false").subscribe(response => {
          this.bookingTasks = (response as any).data;
        });

        this.showDiscount = false;
        this.discountCode = "";

        this.NewBooking = (response as booking_returndata).data;

        if(this.NewBooking.PublicBooking)
        {
          this.validPaymentAmount = this.NewBooking.totalpublicdeposit;
        }
        else{
          this.validPaymentAmount = this.NewBooking.totalvenuedeposit;
        }

        this.dosummary();

      }
      else
      {
        this.messageService.add({ severity: 'error', summary: 'Not Added', detail:(this.httpResponse.messages[0])});
      }
    }, error => {
      this.messageService.add({ severity: 'error', summary: 'Not Added', detail: error.messages[0] });
    })
}

  removeDiscount()
  {
    this.busyService.busy();

    this.NewBooking.discounts = null;
    this.NewBooking.membershipid = null;
    this.NewBooking.salestype = 0;

    this.http.put<booking_returndata>(bmxurl + "/savebooking/true", this.NewBooking).subscribe(response => {
      this.httpResponse = (response as booking_returndata);     

      this.BookingResponse = this.httpResponse.data

        this.NewBooking = this.BookingResponse.bookingObj;

        this.validPaymentAmount = this.NewBooking.outstanding;
  
        this.paymentAmount = this.BookingResponse.bookingObj.total;
        let NumPeople: number = 0;
        this.NewBooking.resources[0].admissions.forEach(adm => {
          NumPeople += adm.noofpeople;
        });
  
        this.paymentAmount = this.BookingResponse.bookingObj.total;
        //this.OutstandingBalance = this.BookingResponse.bookingObj.outstanding;
        const formatter = new Intl.NumberFormat('en-GB', {
          style: 'currency',
          currency: this.CurrencySymbol});
  
        this.startTimes = null;
        this.startTimesFiltered = null;
    
        this.messageService.add({ severity: 'success', summary: 'Discount Removed', detail: 'Your discount has been removed' });

        this.dosummary();
        this.busyService.idle();

    }, error => {
      this.busyService.idle();
    })
  }

  ChangeTime(){
    this.viewportScroller.scrollToPosition([0, 900]);

    this.startTimes = [];

    this.donePartyRooms();
    this.getAvailability();
  }

  checkchanges(){

    this.ShowCheckButton = false;

    this.startTimes = [];

    this.donePartyRooms();
    this.getAvailability();
  }

  donePartyRooms()
  {   
    this.ShowCheckButton = true;

    this.startTimes = [];
    this.customerSelectedResources = [];

    let ResourcesToProcess = [...this.PossibleResources]
    ResourcesToProcess.forEach(PR => {
      if(PR.selectionmode == 'LIST' || PR.selectionmode == 'SYSTEMLIST')
      {
          PR.selectableresources.forEach(innerPR => {
            if(innerPR.ignore)
            {
              let chosenResource: resource = {
                groupname: PR.groupname,
                id: PR.id,
                resourceId: PR.resourceId,   
                name: PR.name, 
                useClasses: PR.useClasses,
                exclusive: PR.exclusive,
                eventid: PR.eventid,
                concurrentUses: PR.concurrentUses,
                maxConcurrent: PR.maxConcurrent,
                disabled: PR.disabled, 
                venueId: PR.venueId,  
                colour: PR.colour,
                orderindex: PR.orderindex,
                length: PR.length,
                classes: PR.classes,
                showonbooking:PR.showonbooking,
                resources: [],
                isresourcecontainer: PR.isresourcecontainer,
                isconstructed: PR.isconstructed,
                resourcegroupname: PR.resourcegroupname,
                price: PR.price,
                fixedprice: PR.fixedprice,
                tags: PR.tags,
                resourcegroup: PR.resourcegroup,
                selectionmode: PR.selectionmode,
                selectableresources: PR.selectableresources, 
                startwhen: PR.startwhen,
                startTimeOffset: PR.startTimeOffset,
                optional: PR.optional,
                quantityselector: PR.quantityselector,
                quantity: PR.quantity,
                mode: PR.mode,
                inline: PR.inline,
                ignore: PR.ignore,
                admissions: PR.admissions,
                inProgress: PR.inProgress,
                originatingid: PR.originatingid,
                wasoptional: PR.wasoptional,
                wasselected: PR.wasselected,
                isupgrade: PR.isupgrade,
                showinitinerary: PR.showinitinerary,
                showondaysheet: PR.showondaysheet,
                cansplit: PR.cansplit
              }
              chosenResource.resources.push(innerPR);
  
              this.customerSelectedResources.push(chosenResource);
            }
          });
      }
      else if (PR.selectionmode == 'ANY' || PR.selectionmode == 'SYSTEMANY')
      {
        if (PR.selectableresources?.some((r: any) => r.ignore) && (PR.selectionmode === 'ANY' || this.allowResourcesChangedManually))
        {
          PR.selectableresources.forEach((innerPR: any) => {
            if(innerPR.ignore)
            {
              let chosenResource: resource = {
                groupname: PR.groupname,
                id: PR.id,
                resourceId: PR.resourceId,
                name: PR.name,
                useClasses: PR.useClasses,
                exclusive: PR.exclusive,
                eventid: PR.eventid,
                concurrentUses: PR.concurrentUses,
                maxConcurrent: PR.maxConcurrent,
                disabled: PR.disabled,
                venueId: PR.venueId,
                colour: PR.colour,
                orderindex: PR.orderindex,
                length: PR.length,
                classes: PR.classes,
                showonbooking: PR.showonbooking,
                resources: [],
                isresourcecontainer: PR.isresourcecontainer,
                isconstructed: PR.isconstructed,
                resourcegroupname: PR.resourcegroupname,
                price: PR.price,
                fixedprice: PR.fixedprice,
                tags: PR.tags,
                resourcegroup: PR.resourcegroup,
                selectionmode: PR.selectionmode,
                selectableresources: PR.selectableresources,
                startwhen: PR.startwhen,
                startTimeOffset: PR.startTimeOffset,
                optional: PR.optional,
                quantityselector: PR.quantityselector,
                quantity: PR.quantity,
                mode: PR.mode,
                inline: PR.inline,
                ignore: PR.ignore,
                admissions: PR.admissions,
                inProgress: PR.inProgress,
                originatingid: PR.originatingid,
                wasoptional: PR.wasoptional,
                wasselected: PR.wasselected,
                isupgrade: PR.isupgrade,
                showinitinerary: PR.showinitinerary,
                showondaysheet: PR.showondaysheet,
                cansplit: PR.cansplit
              }
              chosenResource.resources.push(innerPR);
              this.customerSelectedResources.push(chosenResource);
            }
          });
        }
        else
        {
          this.customerSelectedResources.push(PR);
        }
      }
      else
      {
        this.customerSelectedResources.push(PR);
      }
    });

    //ResourcesToProcess.forEach(PR => {
      // if(PR.selectionmode == 'LIST')
      // {
      //   PR.resources.forEach(innerPR => {
      //     if(innerPR.ignore)
      //     {
      //       let chosenResource: resource = {
      //         groupname: PR.groupname,
      //         id: PR.id,
      //         resourceId: PR.resourceId,   
      //         name: PR.name, 
      //         useClasses: PR.useClasses,
      //         exclusive: PR.exclusive,
      //         eventid: PR.eventid,
      //         concurrentUses: PR.concurrentUses,
      //         maxConcurrent: PR.maxConcurrent,
      //         disabled: PR.disabled, 
      //         venueId: PR.venueId,  
      //         colour: PR.colour,
      //         orderindex: PR.orderindex,
      //         length: PR.length,
      //         classes: PR.classes,
      //         showonbooking:PR.showonbooking,
      //         resources: [],
      //         isresourcecontainer: PR.isresourcecontainer,
      //         isconstructed: PR.isconstructed,
      //         resourcegroupname: PR.resourcegroupname,
      //         price: PR.price,
      //         fixedprice: PR.fixedprice,
      //         tags: PR.tags,
      //         resourcegroup: PR.resourcegroup,
      //         selectionmode: PR.selectionmode,
      //         selectableresources: PR.selectableresources, 
      //         startwhen: PR.startwhen,
      //         startTimeOffset: PR.startTimeOffset,
      //         optional: PR.optional,
      //         quantityselector: PR.quantityselector,
      //         quantity: PR.quantity,
      //         mode: PR.mode,
      //         inline: PR.inline,
      //         ignore: PR.ignore,
      //         admissions: PR.admissions,
      //         inProgress: PR.inProgress,
      //         originatingid: PR.originatingid,
      //         wasoptional: PR.wasoptional,
      //         wasselected: PR.wasselected,
      //       }
      //       chosenResource.resources.push(innerPR);

      //       this.customerSelectedResources.push(chosenResource);
      //     }
      //   });
      // }
    //});

    // ResourcesToProcess.forEach(PR => {
    //   if(PR.mode == 'SIMPLE' || PR.mode == null)
    //   {
    //     this.customerSelectedResources.push(PR);
    //   }
    //   else
    //   {
    //     if(PR.resources != null && PR.resources.length > 0)
    //     {
    //       PR.resources.forEach(innerPR => {
    //         //if(innerPR.ignore)
    //         //{
    //           let chosenResource: resource = {
    //             groupname: PR.groupname,
    //             id: PR.id,
    //             resourceId: PR.resourceId,   
    //             name: PR.name, 
    //             useClasses: PR.useClasses,
    //             exclusive: PR.exclusive,
    //             eventid: PR.eventid,
    //             concurrentUses: PR.concurrentUses,
    //             maxConcurrent: PR.maxConcurrent,
    //             disabled: PR.disabled, 
    //             venueId: PR.venueId,  
    //             colour: PR.colour,
    //             orderindex: PR.orderindex,
    //             length: PR.length,
    //             classes: PR.classes,
    //             showonbooking:PR.showonbooking,
    //             resources: [],
    //             isresourcecontainer: PR.isresourcecontainer,
    //             isconstructed: PR.isconstructed,
    //             resourcegroupname: PR.resourcegroupname,
    //             price: PR.price,
    //             fixedprice: PR.fixedprice,
    //             tags: PR.tags,
    //             resourcegroup: PR.resourcegroup,
    //             selectionmode: PR.selectionmode,
    //             selectableresources: PR.selectableresources, 
    //             startwhen: PR.startwhen,
    //             startTimeOffset: PR.startTimeOffset,
    //             optional: PR.optional,
    //             quantityselector: PR.quantityselector,
    //             quantity: PR.quantity,
    //             mode: PR.mode,
    //             inline: PR.inline,
    //             ignore: PR.ignore,
    //             admissions: PR.admissions,
    //             inProgress: PR.inProgress,
    //             originatingid: PR.originatingid,
    //             wasoptional: PR.wasoptional,
    //             wasselected: PR.wasselected,
    //           }
    //           chosenResource.resources.push(innerPR);

    //           this.customerSelectedResources.push(chosenResource);
    //         //}
    //       });
    //     }
    //     else{
    //       this.customerSelectedResources.push(PR);
    //     }
    //   }
    // });


  }

  // doLinkedAdmissions()
  // {
  //   let totalNumberOfLinked = 0;

  //   this.SelectedAdmissions.forEach(adm => {

  //     if(adm.linkedadmissions != null)
  //     {
  //       adm.linkedadmissions.forEach(ladm => {
  //         let linkedAdm = this.SelectedAdmissions.find(a => a.admissionid == ladm.admissionid);

  //         if(linkedAdm != null)
  //         {
  //           totalNumberOfLinked += Number(linkedAdm.noofpeople);
  //         }
  //       });

  //       if(adm.onlysetmax)
  //       {
  //         adm.max = Number(totalNumberOfLinked);
  //         if (adm.max < adm.min)
  //           adm.max = adm.min;
  //         adm.fixed = false;
  //       }
  //       else
  //       {
  //         adm.noofpeople = Number(totalNumberOfLinked);
  //         adm.fixed = true;
  //       }
  //     }
  //   });

  // }

  changeAdmissions()
  {
    this.doLinkedAdmissions();
    this.isTimeAvailable(this.NewBooking.startTime);
  }

  saveUpgradess()
  {

    let TempReources: any = [];

    this.NewBooking.resources.forEach(element => {
      if(element.isupgrade != true)
      {
        // let index = this.NewBooking.resources.indexOf(element);
        // if (index > -1) {
        //   this.NewBooking.resources.splice(index, 1);
        // }
        TempReources.push(element);
      }
    });

    this.NewBooking.resources = TempReources;

    this.busyService.busy();
    if (this.CurrentUpgrade != null)
    {
      this.CurrentUpgrade.upgrade.resources.forEach(element => {
        element.isupgrade = true;
        element.packageupgradeid = this.CurrentUpgrade.packageupgradeid;
        this.NewBooking.resources.push(element);
      });
    }

    this.isUpgradeTimeAvailable(this.NewBooking.startTime, false);
        
  }

  private mergeExtraQuestions(extras: any[]){
    if(extras == null || this.packageExtrasNew == null)
      return;

    extras.forEach(extra => {
      if(extra.question == null || extra.question === '')
      {
        const master = this.packageExtrasNew.find(pe =>
          pe.id === extra.id || pe.packageExtraId === extra.packageExtraId || pe.extraId === extra.extraId);

        if(master != null && master.question)
        {
          extra.question = master.question;
        }
      }
    });
  }

  saveExtras(){

    this.allQuestionsValid = true;
    this.packageExtras.forEach(element => {
      if(element.question != null)
      {
        if((element.question != "" && element.qty > 0) && (element.answer == null || element.answer == "")) 
        {
          this.allQuestionsValid = false;
        }
      }
      if (element.qty == 0)
      {
        element.answer = "";
      }
    });

    if(this.allQuestionsValid)
    {
      let be: cBookingExtras = {
        BookingId: this.NewBooking.bookingId,
        venueid: this.VenueID,
        extras: this.packageExtras
      }

      let httpResponse: any = null;

      this.http.post<any>(bmxurl + "/BookingExtra", be).subscribe(response => {
        let httpResponse = response;

        if(response.succeeded == true)
        {
          this.messageService.add({severity:'success', summary:'Success', detail: 'Extras updated'});

          this.NewBooking = response.data;
          this.packageExtras = this.NewBooking.extras;
          this.mergeExtraQuestions(this.packageExtras);
          this.dosummary();
        }
        else
        {
        this.messageService.add({severity:'error', summary:'Failure', detail: 'Could not add extra to this booking'});
        }
      }, error => {
        this.messageService.add({severity:'error', summary:'Failure', detail: httpResponse.messages[0]});
      })
    }
  }

  dosummary(){

    this.busyService.busy();

    let admissionsText: string = "";
    let extrasText: string = "";

    this.NewBooking.resources[0].admissions.forEach(adm => {
      if(adm.noofpeople > 0)
        admissionsText += adm.noofpeople + " x " +  adm.name + ", ";
    });

    if(admissionsText.length > 2)
    admissionsText = admissionsText.substring(0, admissionsText.length - 2);

    if(this.NewBooking.extras != null)
    {
      if(this.NewBooking.extras.length > 0)
      {
        this.NewBooking.extras.forEach(element => {
          if(element.qty > 0)
            extrasText += element.name + " x " + element.qty + ", ";
        });
      }
    }

    if(extrasText.length > 2)
    {
      extrasText = extrasText.substring(0, extrasText.length - 2);
    }

    let FullCustomer = "";

    if(this.NewBooking.customer != null)
      {
        let CustomerName = "";
        let CustomerAddress1 = "";
        let CustomerAddress2 = "";
        let CustomerTownCity = "";
        let CustomerPostCode = "";

        CustomerName = this.NewBooking.customer.fullName.trim();

        if (this.NewBooking.customer.address1 != null && this.NewBooking.customer.address1 != "") 
        {
          CustomerAddress1 = this.NewBooking.customer.address1;
        }
        
        if (this.NewBooking.customer.address2 != null && this.NewBooking.customer.address2 != "") 
        {
          CustomerAddress2 = this.NewBooking.customer.address2;
        }

        if (this.NewBooking.customer.townCity != null && this.NewBooking.customer.townCity != "") 
        {
          CustomerTownCity = this.NewBooking.customer.townCity;
        }

        if (this.NewBooking.customer.postCode != null && this.NewBooking.customer.postCode != "") 
        {
          CustomerPostCode = this.NewBooking.customer.postCode;
        }

        FullCustomer = CustomerName + CustomerAddress1 + CustomerAddress2 + CustomerTownCity + CustomerPostCode;
      }

    let customerEmail = "";
    let customerMobile = "";
    let customerFullName = "";

    if(this.NewBooking.customer != null)
    {
      customerFullName = this.NewBooking.customer.fullName
      customerMobile = this.NewBooking.customer.mobile
      customerEmail = this.NewBooking.customer.email
    }

    let newBookingSummary:cBookingsummary = {
      Disabled: this.NewBooking.disabled,
      bookingId: this.NewBooking.bookingId,
      bookingIdHR: this.NewBooking.bookingIdHR,
      admissions: admissionsText,
      startTime: this.NewBooking.startTime,
      endTime: this.NewBooking.endTime,
      name: this.NewBooking.name,
      arrival: this.NewBooking.arrival,
      guests: this.NewBooking.guests,
      total: this.NewBooking.total,
      outstanding: this.NewBooking.outstanding,
      paid: Number(this.NewBooking.total) - Number(this.NewBooking.outstanding),
      totaldiscounts: Number(this.NewBooking.totaldiscounts),
      totalbookingfees: Number(this.NewBooking.totalbookingfees ?? this.NewBooking.bookingfee ?? 0),
      bookingfee: Number(this.NewBooking.bookingfee ?? 0),
      totalbookingfee: Number(this.NewBooking.totalbookingfee ?? 0),
      customerName: customerFullName,
      customerAddress: FullCustomer,
      customerMobile: customerMobile,
      customerEmail:  customerEmail,
      packageName:  this.NewBooking.packageName,
      publicBooking: this.NewBooking.publicBooking,
      extras: extrasText,
      upgrade: this.NewBooking.upgrade,
      upgradetext: this.NewBooking.upgradetext,
      addontext: this.NewBooking.addontext,
      itinerary: this.NewBooking.itinerary,
      notes: this.NewBooking.notes
    }

    this.BookingSummary = newBookingSummary;

    this.busyService.idle();
  }

  setDate(){
    this.SelectedDate  = new Date(this.NewBooking.startTime);
    this.CalendarHeader = "You selected: " + this.SelectedDate.toDateString();
  }

  showCustomerSearch()
  {
    this.ShowCustomerSearch = true;
    this.CustomerHasBeenEdited = true;
  }

  setPackage(){

    this.busyService.busy();

    this.http.get(bmxurl + "packagelist/" + this.VenueID + "/false/")
    .subscribe(response => {

      if((response as Package_returndata).succeeded){
        this.packages = (response as Package_returndata).data

        this.packages.forEach(element => {
          if(element.packageId == this.NewBooking.packageId)
          {
            this.SelectedPackage = element;
            this.PackageHeader = "You selected: " + this.SelectedPackage.name;
          }
        });
      }
      else{
        this.messageService.add({severity:'error', summary:'Failure', detail: (response as Package_returndata).messages[0]});
      }

      this.busyService.idle();

    }, error => {
      this.messageService.add({severity:'error', summary:'Failure', detail:'Failed to get Packages.'});
    })
  }

  packageChanged()
  {
    this.messageService.add({severity:'info', summary:'Package Changed', detail: 'Please make sure you check the admissions on the booking as they will be reset when changing the package. The summary on the right will show the original admissions.'});
    this.startTimes = [];
    this.ShowCheckButton = true;

    this.donePackage();
  }

  admissionsChanged()
  {
    this.doLinkedDiscounts();
    this.doLinkedAdmissions();

    this.startTimes = [];
    this.ShowCheckButton = true;
  }

  doneDate(){

    this.ShowCheckButton = true;

    this.startTimes = [];

    //If Date changes check whether package is still available
    this.http.get(bmxurl + "packagelist/" + this.VenueID + "/false/" + 
    ('00' + this.SelectedDate.getDate()).slice(-2)+
    ('00' + (Number(this.SelectedDate.getMonth() + 1).toString())).slice(-2)
    +this.SelectedDate.getFullYear().toString().substr(-2))
    .subscribe(response => {
      let PackageCheck:any[] = (response as Package_returndata).data
      let FoundPackage:boolean = false;

      PackageCheck.forEach(packageCheck => {
        if(this.SelectedPackage.packageId == packageCheck.packageId)
          {
            FoundPackage = true;
          }
      });

      if(!FoundPackage)
      {
        this.messageService.add({severity:'warn', summary:'Package not available', detail: 'The Package previously chosen is not available on the date selected.'});
        this.SelectedPackage = null;
        this.Admissions = null;
        this.ShowAdmissions = false;
        this.NewBooking.startTime = null;
        this.ShowSaveButton = false;
      }
      else{
        //Check everything is still available
        //this.isTimeAvailable(this.NewBooking.startTime)
      }

      this.packages = PackageCheck;

    }, error => {
    })
  }

  dohistory(){
    this.http.get(bmxurl + "history/" + this.id).subscribe(response => {
      const httpResponse = response as history_returndata;
      if(httpResponse.succeeded == true)
      {
        this.expandedHistory.clear();
        this.historyItems = httpResponse.data.sort((a, b) =>
          new Date(b.itemdatetime).getTime() - new Date(a.itemdatetime).getTime()
        );
      }
      else
      {
        this.messageService.add({severity:'error', summary:'Failure', detail: 'Could not get history for this booking'});
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Failure', detail: 'Could not get history for this booking'});
    })
  }

  donePackage(){
    this.startTimes = [];

    this.customerSelectedResources = [];
    this.SelectedResources = [];
    
    this.SelectedAdmissions = [];

    this.Admissions = this.SelectedPackage.admissions;

    this.SelectedPackage.admissions.forEach(adm => {
      var newAdm: admission = {
        id: adm.id,
        admissionid: adm.admissionid,
        classid: adm.classid,
        noofpeople: adm.min,
        price: adm.price,
        name: adm.name,
        index: adm.index,
        max: adm.max,
        min: adm.min,
        venueid: adm.venueid,
        disabled: adm.disabled,
        admissionClass: adm.admissionClass,
        bookingwizardtext: adm.bookingwizardtext,
        fixedPrice: adm.fixedPrice,
        participant: adm.participant,
        mustinclude: adm.mustinclude,
        eventtickettype: adm.eventtickettype,
        counter: adm.counter,
        uselinkeddiscounts: adm.uselinkeddiscounts,
        linkedadmissions: adm.linkedadmissions,
        linkeddiscounts: adm.linkeddiscounts,
        uselinkedadmissions: adm.uselinkedadmissions,
        maxlinkeddiscounts: adm.maxlinkeddiscounts,
        maxlinkedadmissions:adm.maxlinkedadmissions,
        countstowardsmax: adm.countstowardsmax,
        countstowardsmin: adm.countstowardsmin,
        message: adm.message,
        fixed: adm.fixed,
        onlysetmax: adm.onlysetmax
    }

    this.SelectedAdmissions.push(newAdm);
    });

    this.ShowAdmissions = true;

    this.SelectedPackage.resources.forEach(res => {

      let selectableinnerresources: any[] = [];
      if(res.selectableresources != null && res.selectableresources.length > 0)
      {
        res.selectableresources.forEach(innerRes => {
          if(innerRes.disabled != true)
          {
            selectableinnerresources.push(innerRes);
          }
        });
      }

      var newRes: cResource = {
        groupname: uuidv4(),
        id: res.id,
        resourceId: res.resourceId,   
        name: res.name,
        useClasses: res.useClasses,
        exclusive: res.exclusive,
        eventid: res.eventid,
        concurrentUses: res.concurrentUses,
        maxConcurrent: res.maxConcurrent,
        disabled: res.disabled,
        venueId: res.venueId,
        colour: res.colour,
        orderindex: res.orderindex,
        length: res.length,
        classes:  res.classes,
        showonbooking:res.showonbooking,
        resources: selectableinnerresources,
        isresourcecontainer: res.isresourcecontainer,
        isconstructed: res.isconstructed,
        resourcegroupname: res.resourcegroupname,
        price: res.price,
        fixedprice: res.fixedprice,
        tags: res.tags,
        resourcegroup: res.resourcegroup,
        selectionmode: res.selectionmode,
        selectableresources: res.selectableresources,
        startwhen: res.startwhen,
        startTimeOffset: res.startTimeOffset,
        optional: res.optional,
        quantityselector: res.quantityselector,
        quantity: res.quantity,
        mode: res.mode,
        inline: res.inline,
        ignore: res.ignore,
        admissions: res.admissions,
        inProgress: res.inProgress,
        originatingid: res.originatingid,
        wasoptional: res.wasoptional,
        wasselected: res.wasselected,
        isupgrade: res.isupgrade,
        packageupgradeid: res.packageupgradeid,
        showinitinerary: res.showinitinerary,
        showondaysheet: res.showondaysheet,
        cansplit: res.cansplit
    }

    this.SelectedResources.push(newRes);
    });

    //Get day for selected date.
    let day = this.SelectedDate.getDay();

    this.packageExtras = [];

    if(this.SelectedPackage.extras != null)
    {
      switch (day)
      {
        case 0:
          this.packageExtras = this.SelectedPackage.extras.filter(obj => obj.sunday == true);
          break;
        case 1:
          this.packageExtras = this.SelectedPackage.extras.filter(obj => obj.monday == true);
          break;
        case 2:
          this.packageExtras = this.SelectedPackage.extras.filter(obj => obj.tuesday == true);
          break;
        case 3:
          this.packageExtras = this.SelectedPackage.extras.filter(obj => obj.wednesday == true);
          break;
        case 4:
          this.packageExtras = this.SelectedPackage.extras.filter(obj => obj.thursday == true);
          break;
        case 5:
          this.packageExtras = this.SelectedPackage.extras.filter(obj => obj.friday == true);
          break;
        case 6:
          this.packageExtras = this.SelectedPackage.extras.filter(obj => obj.saturday == true);
          break;
        default:
          this.packageExtras = this.SelectedPackage.extras.filter(obj => obj.sunday == true);
          break;
      }
    }

    this.packageExtras.forEach(ext => {
      ext.qty = 0;
     });

     if(this.packageExtras.length > 0)
        this.PackageHasExtras = true;

    this.SelectedResources.forEach(element => {
      if(element.mode == "COMPLEX")
      {
        this.includesComplexResources = true;
      }
      else{
        this.includesComplexResources = false;
      }
      if(element.selectionmode != "SYSTEMANY" && element.selectionmode != "SYSTEMLIST")
      {
        this.systemChoosesAllResources = false;
      }
      else
      {
        this.systemChoosesAllResources = true;
      }

      if(element.optional)
      {
        this.includesOptionalResources = true;
      }
    });

    // if(!this.includesComplexResources || this.systemChoosesAllResources)
    // {
    //   this.customerSelectedResources = this.SelectedPackage.resources;
    // }

    this.customerSelectedResources = this.NewBooking.resources;

    if(this.includesComplexResources)
    {
      this.partyroomsVisible = true;
    }
    else
    {
      this.partyroomsVisible = false;
    }

    //this.sumAdmissions();

    //this.isTimeAvailable(this.NewBooking.startTime);

    this.setupPossibleResources();

  }

  checkMoreTimes()
  {
    this.getAvailability();
  }

  printConfirmation()
  {
    this.showPrintConfirmations = true;
    this.http.get(bmxurl + "print/" + this.VenueID + "/" + this.NewBooking.bookingId).subscribe(response => {
      this.confHTML = (response as conf_returndata).data.toString();
    }, error => {
      this.messageService.add({severity:'error', summary:'Failure', detail:'Failed to get Payment Types.'});
    })

  }

  getAvailability(){

    if(this.SelectedPackage == null)
    {
      this.messageService.add({severity:'error', summary:'No Package', detail: 'Please select a package before trying to get availability'});
      return;
    }
    else
    {
      this.busyService.busy();

      let totalNoOfPeople: number = 0;

      const AvailabilityReq = {} as AvailabilityReq;

      AvailabilityReq.Admissions = [] as admission[];

      this.SelectedAdmissions.forEach(adm => {
      
        AvailabilityReq.Admissions.push(adm);
        totalNoOfPeople += adm.noofpeople;
        
    });

      AvailabilityReq.packageId = this.SelectedPackage.packageId;
      AvailabilityReq.NoOfPeople =  totalNoOfPeople;
      AvailabilityReq.venueid = this.VenueID;
      AvailabilityReq.StartTime =  this.SelectedDate.getFullYear() + "-" +  (this.SelectedDate.getMonth() + 1) + "-" +  this.SelectedDate.getDate() + "T00:00:00.000Z";
      AvailabilityReq.DiagnosticMode = false;
      AvailabilityReq.IgnoreExistingBooking = true;
      AvailabilityReq.ExistingBookingID = this.NewBooking.bookingId;

      if(this.useNewPackageSettings)
      {
        if(this.customerSelectedResources != null && this.customerSelectedResources.length > 0)
        {
          AvailabilityReq.Resources = this.customerSelectedResources;
        }
        else
        {
          if(this.SelectedPackage.packageId == this.NewBooking.packageId)
            {
              AvailabilityReq.Resources = this.NewBooking.resources;
            }
            else
            {
              AvailabilityReq.Resources = this.customerSelectedResources;
            }
        }
      }
      else
      {
        if(this.SelectedPackage.packageId == this.NewBooking.packageId)
        {
          AvailabilityReq.Resources = this.NewBooking.resources;
        }
        else
        {
          AvailabilityReq.Resources = this.customerSelectedResources;
        }
      }
      
      this.http.post<availabletimes_returndata>(bmxurl + "/Availability", AvailabilityReq).subscribe(response => {
        if((response as availabletimes_returndata).succeeded)
        {
          this.startTimes =(response as availabletimes_returndata).data
          let found: Boolean = false;

          this.startTimesFiltered = [];
          this.startTimes.forEach(element => {
            if(element.timeAvailable)
            {
              this.startTimesFiltered.forEach(innerelement => {
                if(innerelement.time == element.time)
                  found = true;
              });

              if(!found)
              {
                this.startTimesFiltered.push(element);
              }
              found = false;
            }
          });

          this.busyService.idle();
          if(response.messages != null && response.messages.length > 0)
          {
            this.messageService.add({severity:'info', summary:'Info', detail: response.messages[0]});
          }
        }
        else
        {
          this.busyService.idle();
          this.messageService.add({severity:'error', summary:'Error', detail: response.messages[0]});
        }

      }, error => {
        this.busyService.idle();
        this.messageService.add({severity:'error', summary:'Error', detail: 'An error occurred while trying to get availability'});
    })
  }

  }

  isTimeAvailable(inTime: Date, alternativetimes: boolean = true) {

    this.busyService.busy();

    this.donePartyRooms();

    let totalNoOfPeople: number = 0;

    const AvailabilityReq = {} as AvailabilityReq;

    AvailabilityReq.Admissions = [] as admission[];

    this.SelectedAdmissions.forEach(adm => {
      AvailabilityReq.Admissions.push(adm);
      totalNoOfPeople += adm.noofpeople;
   });

    AvailabilityReq.packageId = this.SelectedPackage.packageId;
    AvailabilityReq.NoOfPeople =  totalNoOfPeople;
    AvailabilityReq.venueid = this.VenueID;
    AvailabilityReq.StartTime =  this.SelectedDate.getFullYear() + "-" +  (this.SelectedDate.getMonth() + 1) + "-" +  this.SelectedDate.getDate() + "T00:00:00.000Z";
    AvailabilityReq.DiagnosticMode = false;
    AvailabilityReq.IgnoreExistingBooking = true;
    AvailabilityReq.ExistingBookingID = this.NewBooking.bookingId;
    //AvailabilityReq.Resources = this.customerSelectedResources;
    AvailabilityReq.Resources = this.NewBooking.resources;
    let found: boolean = false;

    this.http.post<availabletimes_returndata>(bmxurl + "/Availability", AvailabilityReq).subscribe(response => {
      let startTimeCheck:any = (response as availabletimes_returndata).data

      if(startTimeCheck != null && startTimeCheck.length > 0)
      {
        startTimeCheck.forEach(element => {
          let elementTime = ('00' + new Date(element.time).getHours()).slice(-2) + ":" + ('00' + new Date(element.time).getMinutes()).slice(-2)
          let ChosenTime = ('00' + new Date(inTime).getHours()).slice(-2) + ":" + ('00' + new Date(inTime).getMinutes()).slice(-2)
          if(elementTime == ChosenTime)
          {
            if(element.timeAvailable)
            {
              found = true;
            }
          }
        });
      }
      
      if(found)
      {
        this.messageService.add({severity:'success', summary:'Time available', detail: 'The time previously chosen is still available for the date selected!'});
        this.ShowSaveButton = true;
        this.busyService.idle();
      }
      else
      if(!found && alternativetimes)
      {
        this.messageService.add({severity:'warn', summary:'Time unavailable', detail: 'The time previously chosen is no longer available, please select an alternative.'});
        this.getAvailability();
        this.busyService.idle();
      }

    }, error => {
      this.messageService.add({severity:'warn', summary:'Time unavailable', detail: 'The time previously chosen is no longer available, please select an alternative.'});
          this.getAvailability();
          this.busyService.idle();
    });


  }

  isUpgradeTimeAvailable(inTime: Date, alternativetimes: boolean = true) {

    this.busyService.busy();

    this.donePartyRooms();

    let totalNoOfPeople: number = 0;

    const AvailabilityReq = {} as AvailabilityReq;

    AvailabilityReq.Admissions = [] as admission[];

    this.SelectedAdmissions.forEach(adm => {
      AvailabilityReq.Admissions.push(adm);
      totalNoOfPeople += adm.noofpeople;
   });

    AvailabilityReq.packageId = this.SelectedPackage.packageId;
    AvailabilityReq.NoOfPeople =  totalNoOfPeople;
    AvailabilityReq.venueid = this.VenueID;
    AvailabilityReq.StartTime =  this.SelectedDate.getFullYear() + "-" +  (this.SelectedDate.getMonth() + 1) + "-" +  this.SelectedDate.getDate() + "T00:00:00.000Z";
    AvailabilityReq.DiagnosticMode = false;
    AvailabilityReq.IgnoreExistingBooking = true;
    AvailabilityReq.ExistingBookingID = this.NewBooking.bookingId;
    AvailabilityReq.Resources = this.NewBooking.resources;
    let found: boolean = false;


    this.http.post<availabletimes_returndata>(bmxurl + "/Availability", AvailabilityReq).subscribe(response => {
      let startTimeCheck:any = (response as availabletimes_returndata).data

      if(startTimeCheck != null && startTimeCheck.length > 0)
      {
        startTimeCheck.forEach(element => {
          let elementTime = ('00' + new Date(element.time).getHours()).slice(-2) + ":" + ('00' + new Date(element.time).getMinutes()).slice(-2)
          let ChosenTime = ('00' + new Date(inTime).getHours()).slice(-2) + ":" + ('00' + new Date(inTime).getMinutes()).slice(-2)
          if(elementTime == ChosenTime)
          {
            if(element.timeAvailable)
            {
              found = true;

              //remove upgrades from resources
              // this.NewBooking.resources.forEach(res => {
              //   if(res.isupgrade == true)
              //   {
              //     let index = this.NewBooking.resources.indexOf(res);
              //     if (index > -1) {
              //       this.NewBooking.resources.splice(index, 1);
              //     }
              //   }
              // });

              this.NewBooking.resources = [];

              //Add upgrades to resources
              element.resources.forEach(res => {
                this.NewBooking.resources.push(res);
              }
              );
            }
          }
        });
      }
      
      if(found)
      {
        this.NewBooking.disabled = false;
        this.savebooking(this.NewBooking);
      }
      else
      {
        this.messageService.add({severity:'warn', summary:'Time unavailable', detail: 'The selected upgrade is not available at this time.'});
        this.getAvailability();
        this.busyService.idle();
      }

    }, error => {
      this.messageService.add({severity:'warn', summary:'Time unavailable', detail: 'An error occurred while checking availability'});
          this.getAvailability();
          this.busyService.idle();
    });


  }

  bookExistingSlotTime(inTime: Date) {

    this.donePartyRooms();

    this.busyService.busy();
    let totalNoOfPeople: number = 0;

    const AvailabilityReq = {} as AvailabilityReq;

    AvailabilityReq.Admissions = [] as admission[];

    this.SelectedAdmissions.forEach(adm => {
      AvailabilityReq.Admissions.push(adm);
      totalNoOfPeople += adm.noofpeople;
   });

   if(totalNoOfPeople >  this.NewBooking.quw)
   {

   }

    AvailabilityReq.packageId = this.SelectedPackage.packageId;
    AvailabilityReq.NoOfPeople =  totalNoOfPeople;
    AvailabilityReq.venueid = this.VenueID;
    AvailabilityReq.StartTime =  this.SelectedDate.getFullYear() + "-" +  (this.SelectedDate.getMonth() + 1) + "-" +  this.SelectedDate.getDate() + "T00:00:00.000Z";
    AvailabilityReq.DiagnosticMode = false;
    AvailabilityReq.IgnoreExistingBooking = true;
    AvailabilityReq.ExistingBookingID = this.NewBooking.bookingId;
    AvailabilityReq.Resources = this.customerSelectedResources;
    let found: boolean = false;

    this.http.post<availabletimes_returndata>(bmxurl + "/Availability", AvailabilityReq).subscribe(response => {
      let startTimeCheck:any = response.data

      let SlotTime;
      startTimeCheck.forEach(element => {
        let elementTime = ('00' + new Date(element.time).getHours()).slice(-2) + ":" + ('00' + new Date(element.time).getMinutes()).slice(-2)
        let ChosenTime = ('00' + new Date(inTime).getHours()).slice(-2) + ":" + ('00' + new Date(inTime).getMinutes()).slice(-2)
        if(elementTime == ChosenTime)
        {
          found = true;
          SlotTime = element;
        }
      });

      if(found)
      {
        this.bookSlot(SlotTime);
      }
      else
      {
        this.messageService.add({severity:'error', summary:'Cannot save time', detail: 'The Time selected could not be saved'});
        this.ShowSaveButton = true;
        this.busyService.idle();
      }

    }, error => {
      this.messageService.add({severity:'warn', summary:'Time unavailable', detail: 'The time previously chosen is no longer available, please select an alternative.'});
          this.getAvailability();
          this.busyService.idle();
    });
  }

  doLinkedDiscounts()
  {
    this.totalDiscount = 0;

    let totalNumberOfLinkedDiscounts = 0;

    this.SelectedAdmissions.forEach(adm => {

      if(adm.linkeddiscounts != null)
      {
        adm.linkeddiscounts.forEach(ladm => {
          let linkedDis = this.SelectedAdmissions.find(a => a.admissionid == ladm.admissionid);

          if(linkedDis != null)
          {
            if(linkedDis.noofpeople >= ladm.threshold)
            {
              let numberOfPeopleForDiscount = Math.floor(linkedDis.noofpeople / ladm.threshold);

              if(adm.noofpeople < numberOfPeopleForDiscount)
              {
                numberOfPeopleForDiscount = adm.noofpeople;
              }

              this.totalDiscount += Number(adm.price * numberOfPeopleForDiscount) * Number(ladm.percentagediscount / 100);
            }
          }
        });
      }
    });
  }

  // doLinkedAdmissions()
  // {
  //   let totalNumberOfLinked = 0;

  //   this.SelectedAdmissions.forEach(adm => {

  //     let OldNoOfPeople = adm.min;

  //     if(adm.linkedadmissions != null)
  //     {
  //       adm.linkedadmissions.forEach(ladm => {
  //         let linkedAdm = this.SelectedAdmissions.find(a => a.admissionid == ladm.admissionid);

  //         if(linkedAdm != null)
  //         {
  //           totalNumberOfLinked += Number(linkedAdm.noofpeople);
  //         }
  //       });

  //       if(adm.onlysetmax)
  //       {
  //         adm.max = Number(totalNumberOfLinked);
  //         if (adm.max < adm.min)
  //         {
  //           adm.max = adm.min;
  //         }
  //         if(Number(adm.noofpeople) > Number(totalNumberOfLinked))
  //         {
  //           if(Number(OldNoOfPeople) > Number(totalNumberOfLinked))
  //           {
  //             adm.noofpeople = Number(OldNoOfPeople);
  //           }
  //           else
  //           {
  //             adm.noofpeople = Number(totalNumberOfLinked);
  //           }
  //         }
  //         adm.fixed = false;
  //       }
  //       else
  //       {
  //         adm.noofpeople = Number(totalNumberOfLinked);
  //         adm.fixed = true;
  //       }
  //     }
  //   });

  // }

  // doLinkedAdmissions()
  // {
  //   let totalNumberOfLinked = 0;

  //   this.SelectedAdmissions.forEach(adm => {

  //     if(adm.linkedadmissions != null && adm.linkedadmissions.length > 0)
  //     {
  //       adm.linkedadmissions.forEach(ladm => {
  //         //toddlers - go and find the admission that it links to
  //         totalNumberOfLinked = 0;
  //         this.SelectedAdmissions.forEach(innerAdm => {
  //           if(ladm.admissionid == innerAdm.admissionid)
  //           {
  //             totalNumberOfLinked += Number(innerAdm.noofpeople);
  //           }
  //         });
  //       });

  //       if(adm.onlysetmax)
  //       {
  //         adm.max = Number(totalNumberOfLinked);
  //         if (adm.max < adm.min)
  //         {
  //           adm.max = adm.min;
  //         }
  //         if(Number(adm.noofpeople) > Number(totalNumberOfLinked))
  //         {
  //           adm.noofpeople = Number(totalNumberOfLinked);
  //         }
  //         adm.fixed = false;
  //       }
  //       else
  //       {
  //         adm.noofpeople = Number(totalNumberOfLinked);
  //         adm.fixed = true;
  //       }
  //     }
  //   });

  // }

    doLinkedAdmissions() {
    this.SelectedAdmissions.forEach(adm => {
      if (adm.linkedadmissions && adm.linkedadmissions.length > 0) {
        let totalNumberOfLinked = 0;

        adm.linkedadmissions.forEach(ladm => {
          const matching = this.SelectedAdmissions.find(innerAdm => innerAdm.admissionid === ladm.admissionid);
          if (matching) {
            totalNumberOfLinked += Number(matching.noofpeople);
          }
        });

        if (adm.onlysetmax) {
          adm.max = Number(totalNumberOfLinked);

          if (adm.max < adm.min) {
            adm.max = adm.min;
          }

          if (Number(adm.noofpeople) > adm.max) {
            adm.noofpeople = adm.max;
          }

          adm.fixed = false;
        } else {
          adm.noofpeople = Number(totalNumberOfLinked);
          adm.fixed = true;
        }
      }
    });
  }

  sumAdmissions(){

    this.doLinkedDiscounts();

    this.doLinkedAdmissions();

    this.totalAdmissions = this.SelectedAdmissions.map(a => a.noofpeople).reduce(function(a, b)
    {
      return Number(a) + Number(b);
    });

    if((this.totalAdmissions > this.SelectedPackage.max && this.SelectedPackage.max > 0) || (this.totalAdmissions < this.SelectedPackage.min && this.SelectedPackage.min > 0))
    {
      this.totalAdmissionInRange = false;
    }
    else
    {
      this.totalAdmissionInRange = true;
    }

    this.isTimeAvailable(this.NewBooking.startTime);
  }

  returnHome(){}

  searchCustomer(){
    this.http.get(bmxurl + "customer/search/" + this.VenueID + "/" + this.searchCriteria).subscribe(response => {
      this.customersResult = (response as customer[])
    }, error => {
    })

  }

  addselectedCustomer(passCustomer){
    this.searchCriteria = "";

    this.CustomerHeader = "Customer: " +  passCustomer.firstName + "  " + passCustomer.lastName;

    let newCustomer: Customer = {
      id: null,
      customerid: null,
      firstName: passCustomer.firstName,
      lastName: passCustomer.lastName,
      fullName: passCustomer.firstName + " " + passCustomer.lastName,
      address1: passCustomer.address1,
      address2: passCustomer.address2,
      townCity: passCustomer.townCity,
      postCode: passCustomer.postCode,
      email: passCustomer.email,
      mobile: passCustomer.mobile,
      dob: this.dob,
      venueId: this.VenueID,
      disabled: false,
      bookingid: null
    }

    this.NewBooking.customer = newCustomer;

    this.customersResult = null;
    this.searchCriteria = "";

  }

  addCustomer(){
    //Check Search field for postcode

    if(this.valid_postcode(this.searchCriteria))
    {
      this.postCode = this.searchCriteria
    }
    else if(this.valid_mobile(this.searchCriteria))
    {
      //Check Telephone number
      this.mobile = this.searchCriteria
    }
    else
    {
      this.lastName = this.searchCriteria
    }

    this.ShowCustomerDetails = true;
    this.ProvideMinimalPersonalData = true;

  }

  doneCustomer()
  {
    this.CustomerAllValid = true;

    if(this.ProvideMinimalPersonalData)
    {
      if (this.lastName == "") {
        this.CustomerAllValid = false;
        this.lastNameValid = false;
      }
      else {
        this.lastNameValid = true;
      }

      if (this.email == "") {
        this.CustomerAllValid = false;
        this.EmailValid = false;
      }
      else {
        this.EmailValid = true;
      }

      if (this.mobile == "") {
        this.CustomerAllValid = false;
        this.MobileValid = false;
      }
      else {
        this.MobileValid = true;
      }
    }
    else
    {
      if (this.firstName == "") {
        this.CustomerAllValid = false;
        this.firstNameValid = false;
      }
      else {
        this.firstNameValid = true;
      }

      if (this.lastName == "") {
        this.CustomerAllValid = false;
        this.lastNameValid = false;
      }
      else {
        this.lastNameValid = true;
      }

      if (this.address1 == "") {
        this.CustomerAllValid = false;
        this.Address1Valid = false;
      }
      else {
        this.Address1Valid = true;
      }

      if (this.town == "") {
        this.CustomerAllValid = false;
        this.TownValid = false;
      }
      else {
        this.TownValid = true;
      }

      if (this.postCode == "") {
        this.CustomerAllValid = false;
        this.PostCodeValid = false;
      }
      else {
        this.PostCodeValid = true;
      }

      if (this.email == "") {
        this.CustomerAllValid = false;
        this.EmailValid = false;
      }
      else {
        this.EmailValid = true;
      }

      if (this.mobile == "") {
        this.CustomerAllValid = false;
        this.MobileValid = false;
      }
      else {
        this.MobileValid = true;
      }
    }

    //Check for valid email and mobile

    if (this.email != "") {
      if (!this.validateEmail(this.email)) {
        this.CustomerAllValid = false;
        this.EmailFormatValid = false;
      }
      else {
        this.EmailFormatValid = true;
      }
    }

    if(this.mobile != ""){
      if (!this.validateMobile(this.mobile)) {
        this.CustomerAllValid = false;
        this.MobileFormatValid = false;
      }
      else {
        this.MobileFormatValid = true;
      }
    }

    if(this.CustomerAllValid == true)
    {
      this.CustomerHeader = "Customer: " + this.firstName + "  " + this.lastName;

      let newCustomer: Customer = {
        id: null,
        customerid: null,
        firstName: this.firstName,
        lastName: this.lastName,
        fullName: this.firstName + " " + this.lastName,
        address1: this.address1,
        address2: this.address2,
        townCity: this.town,
        postCode: this.postCode,
        email: this.email,
        mobile: this.mobile,
        dob: this.dob,
        venueId: this.VenueID,
        disabled: false,
        bookingid: null
      }

      this.NewBooking.customer = newCustomer;

      this.saveCustomer();

      this.ShowCustomerDetails = false;
      this.ShowCustomerSearch = false;
      this.customersResult = null;
      this.searchCriteria = "";

      
    }

    this.dosummary();
  }

  updateCustomer()
  {
    this.CustomerAllValid = true;

    if(this.ProvideMinimalPersonalData)
    {
      if (this.NewBooking.customer.lastName == "") {
        this.CustomerAllValid = false;
        this.lastNameEditValid = false;
      }
      else {
        this.lastNameEditValid = true;
      }

      if (this.NewBooking.customer.email == "") {
        this.CustomerAllValid = false;
        this.EmailEditValid = false;
      }
      else {
        this.EmailEditValid = true;
      }

      if (this.NewBooking.customer.mobile == "") {
        this.CustomerAllValid = false;
        this.MobileEditValid = false;
      }
      else {
        this.MobileEditValid = true;
      }
    }
    else
    {
      if (this.NewBooking.customer.firstName == "") {
        this.CustomerAllValid = false;
        this.firstNameEditValid = false;
      }
      else {
        this.firstNameEditValid = true;
      }

      if (this.NewBooking.customer.lastName == "") {
        this.CustomerAllValid = false;
        this.lastNameEditValid = false;
      }
      else {
        this.lastNameEditValid = true;
      }

      if (this.NewBooking.customer.address1 == "") {
        this.CustomerAllValid = false;
        this.Address1EditValid = false;
      }
      else {
        this.Address1EditValid = true;
      }

      if (this.NewBooking.customer.townCity == "") {
        this.CustomerAllValid = false;
        this.TownEditValid = false;
      }
      else {
        this.TownEditValid = true;
      }

      if (this.NewBooking.customer.postCode == "") {
        this.CustomerAllValid = false;
        this.PostCodeEditValid = false;
      }
      else {
        this.PostCodeEditValid = true;
      }

      if (this.NewBooking.customer.email == "") {
        this.CustomerAllValid = false;
        this.EmailEditValid = false;
      }
      else {
        this.EmailEditValid = true;
      }

      if (this.NewBooking.customer.mobile == "") {
        this.CustomerAllValid = false;
        this.MobileEditValid = false;
      }
      else {
        this.MobileEditValid = true;
      }
    }

    //Check for valid email and mobile

    if (this.NewBooking.customer.email != "") {
      if (!this.validateEmail(this.NewBooking.customer.email)) {
        this.CustomerAllValid = false;
        this.EmailFormatEditValid = false;
      }
      else {
        this.EmailFormatEditValid = true;
      }
    }

    if(this.NewBooking.customer.mobile != ""){
      if (!this.validateMobile(this.NewBooking.customer.mobile)) {
        this.CustomerAllValid = false;
        this.MobileFormatEditValid = false;
      }
      else {
        this.MobileFormatEditValid = true;
      }
    }
    
    if(this.CustomerAllValid == true)
    {
      let newCustomer: Customer = {
        id: this.NewBooking.customer.id,
        customerid:  this.NewBooking.customer.customerid,
        firstName:  this.NewBooking.customer.firstName,
        lastName:  this.NewBooking.customer.lastName,
        fullName:  this.NewBooking.customer.firstName + " " + this.NewBooking.customer.lastName,
        address1:  this.NewBooking.customer.address1,
        address2:  this.NewBooking.customer.address2,
        townCity:  this.NewBooking.customer.townCity,
        postCode:  this.NewBooking.customer.postCode,
        email: this.NewBooking.customer.email,
        mobile: this.NewBooking.customer.mobile,
        dob: this.NewBooking.customer.dob,
        venueId: this.VenueID,
        disabled: false,
        bookingid: this.NewBooking.bookingId
      }

      this.http.put<string>(bmxurl + "/customer", newCustomer).subscribe(response => {
        this.BookingResponse = response 
        if(this.BookingResponse.succeeded)
        {
          this.NewBooking = this.BookingResponse.data;
          this.dosummary();

          this.messageService.add({severity:'success', summary:'Success', detail:'Customer updated' });

          this.ShowSaveButton = false;
        }
        else{
          this.messageService.add({severity:'error', summary:'Failure', detail:'This Customer could not be updated' });
        }
      }, error => {
        this.messageService.add({severity:'error', summary:'Failure', detail:'This Customer could not be updated' });
      })
    }
  }

  applyCustomer(passCustomer)
  {
    this.ShowCustomerDetails = true;
    this.firstName = passCustomer.firstName;
    this.lastName = passCustomer.lastName;
    this.address1 = passCustomer.address1;
    this.address2 = passCustomer.address2;
    this.town = passCustomer.townCity;
    this.postCode = passCustomer.postCode;
    this.email = passCustomer.email;
    this. mobile = passCustomer.mobile;

    this.customersResult = null;
    this.searchCriteria = "";

  }

  saveCustomer()
  {
    this.NewBooking.customer.bookingid = this.NewBooking.bookingId;

    this.http.post<any>(bmxurl + "/Customer", this.NewBooking.customer).subscribe(response => {
      if(response.succeeded == true)
        {
          this.messageService.add({severity:'success', summary:'Customer Changed', detail:'Customer successfully changed to: ' + this.NewBooking.customer.fullName});
          this.dosummary();
        }
        else
        {
          this.messageService.add({severity:'error', summary:'Failed to update customer', detail:'Failed to update customer.'});
        }
      }, error => {
      })
    this.ShowCustomerSearch = false;
    this.CustomerHasBeenEdited = false;
  }

  validateEmail(email){ 
    var re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/; 
    return re.test(email); 
  }

  validateMobile(mobile){ 
    var re = /^($|(^\\+)?[0-9()-]*)$/; 
    return re.test(mobile); 
  }

  valid_postcode(postcode) {
    postcode = postcode.replace(/\s/g, "");
    var regex = /^[A-Z]{1,2}[0-9]{1,2} ?[0-9][A-Z]{2}$/i;
    return regex.test(postcode);
  }

  valid_mobile(postcode) {
    postcode = postcode.replace(/\s/g, "");
    var regex = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g;
    return regex.test(postcode);
  }

  doPaymentTypes()
  {
    const cached = localStorage.getItem("PaymentTypes");

    if(cached)
    {
      this.PaymentTypes = JSON.parse(cached).filter(pt => pt.system == false);
      return;
    }

    this.busyService.busy();

    this.http.get(bmxurl + "paymenttypes").subscribe(response => {
      this.PaymentTypes = (response as paymenttypes_returndata).data;

      localStorage.setItem("PaymentTypes", JSON.stringify(this.PaymentTypes));

      this.PaymentTypes = this.PaymentTypes.filter(pt => pt.system == false);

      this.busyService.idle();

    }, error => {
      this.messageService.add({severity:'error', summary:'Failure', detail:'Failed to get Payment Types.'});
    })
  }

  DoValidCheck()
  {
    let AllValid = true;

    if(this.RefundPayment == null || this.RefundPayment == 0)
    {
      AllValid = false;
      this.RefundPaymentValid = false;
    }
    else
    {
      this.RefundPaymentValid = true;
    }

    if(this.RefundReason == null || this.RefundReason == "")
    {
      AllValid = false;
      this.RefundTextValid = false;
    }
    else
    {
      this.RefundTextValid = true;
    }

    return AllValid;
  }

  doRefund()
  {
    if (this.DoValidCheck())
    {
      let newRefund: cRefund={
        venueid: this.VenueID,
        paymentid: this.RefundPaymentId,
        reason: this.RefundReason,
        amount: this.RefundPayment,
        notes: "",
        disabled: false
      }

      this.busyService.busy();
      this.http.post<refund>(bmxurl + "/refund", newRefund).subscribe(response => {
        this.httpResponse = response

        if(this.httpResponse.succeeded)
        {
          this.http.get(bmxurl + "booking/" + this.VenueID + "/" + this.id).subscribe(response => {
            this.NewBooking = (response as booking_returndata).data;
            this.busyService.idle();
            this.displayModalRefund = false;

            this.dosummary();
            this.messageService.add({severity:'success', summary:'Saved', detail:'Refund successful, the refund has been passed to the card issuer and will be processed by them in accordance to their refund policy.'});
            this.RefundReason = "";
            
          }, error => {
            this.messageService.add({severity:'error', summary:'Error', detail: 'Error getting updated booking'});
            this.busyService.idle();
          })
        }
        else
        {
          this.messageService.add({severity:'error', summary:'Not Saved', detail: this.httpResponse.messages[0]});
          this.busyService.idle();
        }
      }, error => {
        this.messageService.add({severity:'error', summary:'Not Saved', detail: this.httpResponse.messages[0]});
        this.busyService.idle();
    })
    
    }
  }
  
  setupRefund(paymentID: string)
  {
    if(this.checkIfRefundallowed())
    {
      let payment: Payment;
      this.RefundPaymentId = paymentID;

      this.http.get(bmxurl + "Payment/" + this.VenueID + "/" + paymentID).subscribe(response => {
        payment = (response as payment_returndata).data;

        this.RefundPayment = payment.amount;
      }, error => {
        })

      this.displayModalRefund = true;
    }
    else
    {
      this.messageService.add({severity:'error', summary:'Not Allowed', detail: 'You do not have authority to refund this payment, please speak to your manager.'});
    }
  }

  checkIfRefundallowed()
  {
    if(this.CurrentLoggedInUser.accesscontrol.name == 'Venue Administrator')
    {
      return true;
    }
    else
    {
      return false;
    }
  }

  resetlock()
  {
    this.paymentButtonLocked = false;
  }

  makeNewPayment()
  {
    //Get number of people
    let NumPeople: number = 0;
    this.NewBooking.resources[0].admissions.forEach(adm => {
      NumPeople += adm.noofpeople;
    });

    this.AllValid = true;

    if (this.validPaymentAmount == null || (this.validPaymentAmount < 0)) {
      this.AllValid = false;
      this.paymentValueValid = false;
    }
    else {
      this.paymentValueValid = true;
      this.AllValid = true;
    }

    if (this.selectedPayment == null) {
      this.AllValid = false;
      this.paymentTypeValid = false;
    }
    else {
      this.paymentTypeValid = true;
      this.AllValid = true;
    }

    if(this.AllValid)
    {
      this.paymentButtonLocked = true;

      const terminalId = localStorage.getItem(`GeneralTerminalName_${this.VenueID}`) ?? '';
      if (this.selectedPayment.name.toLowerCase().includes('card') && terminalId) {
        this.connectTerminalHubEditBooking(terminalId);
        return;
      }

      //Kept because the payment type is cleared once this date is paid, and the other dates of a
      //series are paid after that.
      const paymentMethodName = this.selectedPayment.name;
      const paymentMethodId = this.selectedPayment.id;

      //A payment on one date of a series is split across every date in proportion to what each
      //still owes, so this date takes only its own share of it.
      const seriesShares = this.isSeriesBooking ? this.seriesPaymentShares(this.validPaymentAmount) : null;
      const amountForThisDate = seriesShares == null ? this.validPaymentAmount : seriesShares[0];

      let newPayment: Payment = {
        id: null,
        PaymentId: null,
        BookingId: this.NewBooking.bookingId,
        bookingIdHR: this.NewBooking.bookingIdHR,
        method: paymentMethodName,
        paymenttypeid: paymentMethodId,
        amount: amountForThisDate,
        paymentDate: new Date,
        disabled: false,
        venueid: this.VenueID,
        refunds: null,
        balance: amountForThisDate,
        paymenttype: "booking",
        currency: this.CurrencySymbol,
        tillname: null
      }

      this.NewBooking.payments = [];
      this.NewBooking.payments.push(newPayment);
      this.NewBooking.inProgress = false;

      this.http.post<booking_returndata>(bmxurl + "/Payment", this.NewBooking).subscribe(response => {
        this.BookingResponse = (response as booking_returndata).data  
        
        this.NewBooking =this.BookingResponse;
            
        if(response.succeeded == true)
        {
          //The other dates take their share of the same payment before the screen is refreshed.
          this.paySeriesSiblings(seriesShares, paymentMethodName, paymentMethodId, () => {

          this.http.get(bmxurl + "TasktypeList/" + this.VenueID + "/false").subscribe(response => {
            this.bookingTasks = (response as any).data;
          });

          this.BookingPayments = this.BookingResponse.payments;
          this.NewBooking.totaladmissions = this.BookingResponse.totaladmission;

          this.validPaymentAmount = this.NewBooking.outstanding;

          this.totalPayments = 0;
          this.BookingPayments.forEach(element => {
            this.totalPayments += element.amount;
          });

          this.selectedPayment = null;

          this.dosummary();

          });
        }
        else
        {
          this.messageService.add({severity:'error', summary:'Error', detail: response.messages});
        }
      }, error => {
        this.messageService.add({severity:'error', summary:'Error', detail: error.message});
      })
    }
  }  

  connectTerminalHubEditBooking(terminalId: string): void {
    this.terminalPaymentResolved = false;
    this.terminalPaymentIntentId = '';
    this.showTerminalWaiting = true;
    this.pendingTerminalId = terminalId;

    const payload = {
      venueid: this.VenueID,
      connectedAccountId: localStorage.getItem('RyftSubAccountID') ?? '',
      amount: Math.round(this.validPaymentAmount * 100),
      currency: (this.CurrencySymbol ?? 'GBP').toLowerCase(),
      terminalId: terminalId,
      method: 'BOOKING',
      identifier: this.NewBooking.bookingId
    };

    this.http.post<any>(bmxurl + 'StripeTerminalPaymentInit', payload).subscribe({
      next: (response) => {
        if (!response.succeeded) {
          this.showTerminalWaiting = false;
          const detail = response.messages?.[0] ?? 'Failed to initiate terminal payment';
          if (detail.toLowerCase().includes('payment_intent in progress')) {
            this.showTerminalBusyDialog = true;
          } else {
            this.paymentButtonLocked = false;
            this.messageService.add({ severity: 'error', summary: 'Terminal Error', detail });
          }
          return;
        }

        this.terminalPaymentIntentId = response.data?.paymentIntentId ?? response.data?.id ?? '';

        if (this.terminalPaymentIntentId && this.hubConnection) {
          this.hubConnection.on(this.terminalPaymentIntentId, () => {
            this.ngZone.run(() => this.pollEditBookingForPayment());
          });
        }

        this.terminalPollingIntervalId = setInterval(() => {
          this.ngZone.run(() => this.pollEditBookingForPayment());
        }, 10000);
      },
      error: () => {
        this.showTerminalWaiting = false;
        this.paymentButtonLocked = false;
        this.messageService.add({ severity: 'error', summary: 'Terminal Error', detail: 'Failed to reach terminal payment service' });
      }
    });
  }

  waitForTerminal(): void {
    this.showTerminalBusyDialog = false;
  }

  clearTerminalAndRetryPayment(): void {
    const terminalId = this.pendingTerminalId;
    this.showTerminalBusyDialog = false;
    this.http.get<any>(bmxurl + 'StripeTerminalCancel/' + this.VenueID + '/' + terminalId).subscribe({
      complete: () => {
        this.connectTerminalHubEditBooking(terminalId);
      }
    });
  }

  pollEditBookingForPayment(): void {
    if (this.terminalPaymentResolved) return;

    this.http.get<booking_returndata>(bmxurl + 'booking/' + this.VenueID + '/' + this.NewBooking.bookingId).subscribe({
      next: (response) => {
        if (this.terminalPaymentResolved) return;
        const booking = response.data;
        const matched = (booking.payments ?? []).find(
          (p: any) => (p.PaymentId ?? p.intent) === this.terminalPaymentIntentId
        );
        if (matched) {
          this.completeEditBookingAfterPayment(booking);
        }
      },
      error: () => {}
    });
  }

  completeEditBookingAfterPayment(booking: any): void {
    if (this.terminalPaymentResolved) return;
    this.terminalPaymentResolved = true;
    this.stopTerminalPolling();
    if (this.terminalPaymentIntentId && this.hubConnection) {
      this.hubConnection.off(this.terminalPaymentIntentId);
    }
    this.showTerminalWaiting = false;

    this.NewBooking = booking;
    this.BookingPayments = booking.payments ?? [];
    this.NewBooking.totaladmissions = booking.totaladmission;
    this.validPaymentAmount = booking.outstanding;
    this.totalPayments = 0;
    this.BookingPayments.forEach((p: any) => this.totalPayments += p.amount);
    this.selectedPayment = null;

    this.http.get(bmxurl + 'TasktypeList/' + this.VenueID + '/false').subscribe(response => {
      this.bookingTasks = (response as any).data;
    });

    this.dosummary();
  }

  stopTerminalPolling(): void {
    if (this.terminalPollingIntervalId !== null) {
      clearInterval(this.terminalPollingIntervalId);
      this.terminalPollingIntervalId = null;
    }
  }

  cancelTerminalPayment(): void {
    this.terminalPaymentResolved = true;
    this.stopTerminalPolling();
    if (this.terminalPaymentIntentId && this.hubConnection) {
      this.hubConnection.off(this.terminalPaymentIntentId);
    }
    this.showTerminalWaiting = false;
    this.paymentButtonLocked = false;

    const terminalId = localStorage.getItem(`GeneralTerminalName_${this.VenueID}`) ?? '';
    this.http.get(bmxurl + 'StripeTerminalCancel/' + this.VenueID + '/' + terminalId).subscribe({
      next: () => {},
      error: () => {}
    });
  }

  bookSlot(timeslot: AvailableTimes)
  {
    this.busyService.busy();
    let found: boolean = false;

    var instanceID: any = "BMP1"
    var id:any = this.VenueID;
    var todaysDate: Date = new Date(timeslot.time);
    var thisYear: any = todaysDate.getFullYear();
    var thisMonth: any = ('00' + (todaysDate.getMonth() + 1)).slice(-2);
    var thisDay: any = ('00' + todaysDate.getDate()).slice(-2);
    var fullDate: any = thisYear + thisMonth + thisDay;
  
    //var venueDate: any =  id + "_" + fullDate;

    this.SelectedPackage.resources.forEach(adm => {
      adm.admissions = this.SelectedAdmissions;
   });

    let totalNoOfPeople: number = 0;

    //this.NewBooking.venuedate = venueDate
    this.NewBooking.packageId = this.SelectedPackage.packageId;
    this.NewBooking.guests =  totalNoOfPeople;
    this.NewBooking.startTime = timeslot.time;
    this.NewBooking.PackageName = this.SelectedPackage.name;
    this.NewBooking.venueId = this.VenueID;
    this.NewBooking.resources = timeslot.resources; //this.SelectedPackage.resources;
    this.NewBooking.Disabled = false;
    this.NewBooking.outstanding = 0;
    this.NewBooking.name = "";
    this.NewBooking.salestype = 0;

    //timeslot.resources replaced the booking's resources above and does not always carry
    //the admissions across.
    if (!this.bookingHasAdmissions(this.NewBooking)) {
      this.abandonSaveAndReload(true);
      return;
    }

    this.http.put<booking_returndata>(bmxurl + "/savebooking/true", this.NewBooking).subscribe(response => {
      this.httpResponse = (response as booking_returndata);

      this.BookingResponse = this.httpResponse.data
        this.NewBooking = this.BookingResponse.bookingObj

        if(this.NewBooking.resources != null && this.NewBooking.resources.length > 0)
          this.NewBooking.previousadmissions = JSON.parse(JSON.stringify(this.NewBooking.resources[0].admissions)); 

        let NumPeople: number = 0;
        this.NewBooking.resources[0].admissions.forEach(adm => {
          NumPeople += adm.noofpeople;
        });
  
        this.paymentAmount = this.BookingResponse.bookingObj.total;
        //this.OutstandingBalance = this.BookingResponse.bookingObj.outstanding;

        this.validPaymentAmount = this.NewBooking.outstanding;


        const formatter = new Intl.NumberFormat('en-GB', {
          style: 'currency',
          currency: this.CurrencySymbol});
  
        this.startTimes = null;
        this.startTimesFiltered = null;
  

      this.messageService.add({severity:'success', summary:'Success', detail:'Booking Saved, please check the details are correct on the right;' });
      this.dosummary();

      this.busyService.idle();

      this.ShowSaveButton = false;

      this.busyService.idle();

      this.loaddata();

    }, error => {
      this.busyService.idle();
    })
  }

  //Works out which admissions a rebuilt resource group should inherit. currentEntry is the
  //booking resource being replaced, but by this point NewBooking.resources may already have
  //been swapped for the availability timeslot's resources, which do not always carry
  //admissions - so fall back to BookingResources, the snapshot of the saved booking taken
  //in loaddata() before the resources were overwritten.
  private admissionsForGroup(currentEntry: any, isForThisGroup: (r: any) => boolean): any[]
  {
    if (currentEntry != null && currentEntry.admissions != null && currentEntry.admissions.length > 0) {
      return currentEntry.admissions;
    }

    const savedEntry = this.BookingResources?.find(isForThisGroup);

    if (savedEntry != null && savedEntry.admissions != null && savedEntry.admissions.length > 0) {
      return savedEntry.admissions;
    }

    return [];
  }

  //A booking with no admissions is a broken booking - saving it would persist the loss.
  //The resource arrays handed back by availability and rebuilt by Advanced Edit do not
  //always carry the admissions across, so every whole-booking save is gated on this.
  private bookingHasAdmissions(booking: any): boolean
  {
    if (booking == null || booking.resources == null || booking.resources.length == 0) {
      return false;
    }

    return booking.resources.some((res: any) => res.admissions != null && res.admissions.length > 0);
  }

  //busyTaken tells us whether the caller already incremented the busy counter, so the
  //spinner is balanced before loaddata() takes its own.
  private abandonSaveAndReload(busyTaken: boolean): void
  {
    this.messageService.add({severity:'error', summary:'Error', detail:'An error has occurred, the booking has been reloaded, please try again'});

    if (busyTaken) {
      this.busyService.idle();
    }

    this.loaddata();
  }

  savebooking(booking: any)
  {
    if (!this.bookingHasAdmissions(booking)) {
      this.abandonSaveAndReload(true);
      return;
    }

    this.http.put<booking_returndata>(bmxurl + "/savebooking/true", booking).subscribe(response => {
      this.httpResponse = (response as booking_returndata);     

      this.BookingResponse = this.httpResponse.data
        this.NewBooking = this.BookingResponse.bookingObj

        let NumPeople: number = 0;
        this.NewBooking.resources[0].admissions.forEach(adm => {
          NumPeople += adm.noofpeople;
        });
  
        this.paymentAmount = this.BookingResponse.bookingObj.total;

        this.validPaymentAmount = this.NewBooking.outstanding;


        const formatter = new Intl.NumberFormat('en-GB', {
          style: 'currency',
          currency: this.CurrencySymbol});
  
        this.startTimes = null;
        this.startTimesFiltered = null;
  

      this.messageService.add({severity:'success', summary:'Success', detail:'Booking Saved, please check the details are correct on the right;' });
      this.dosummary();

      this.busyService.idle();

      this.loaddata();
      this.busyService.idle();

    }, error => {
      this.busyService.idle();
    })
  }

  sendSMSConfirmation(){
    this.http.get<any>(bmxurl + "confirmation/" + this.VenueID + "/" + this.NewBooking.bookingId).subscribe(response => {
      if(response.succeeded)
      {
        this.messageService.add({severity:'success', summary:'Success', detail:'SMS Message sent.'});
      }
      else
      {
        this.messageService.add({severity:'error', summary:'Failure', detail: 'Could not send SMS: ' + response.messages[0]});
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Failure', detail: 'An error occurred whilst trying to send the SMS'});
    })
 }

 sendEmailConfirmation(){
    this.http.get<any>(bmxurl + "confirmationemail/" + this.VenueID + "/" + this.NewBooking.bookingId).subscribe(response => {
      if(response.succeeded)
      {
        this.messageService.add({severity:'success', summary:'Success', detail:'Email Message sent.'})
      }
      else
      {
        this.messageService.add({severity:'error', summary:'Failure', detail: 'Could not send Email: ' + response.messages[0]});
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Failure', detail: 'An error occurred whilst trying to send the Email'});
    })
 }

 loadTasks(){
  this.http.get(bmxurl + "bookingtasklist/" + this.VenueID + "/" + this.id + "/false").subscribe(response => {
    this.allTasks = (response as any).data;
  }, error => {
    this.messageService.add({severity:'error', summary:'Failure', detail:'Failed to get Tasks.'});
  });
 }

  saveNotes(){
    let newNotes: any = {
      bookingid: this.NewBooking.bookingId,
      note: this.NewBooking.notes
    }

    this.http.post<string>(bmxurl + "/NotesUpdate", newNotes).subscribe(response => {
      this.BookingResponse = response 

      this.messageService.add({severity:'success', summary:'Success', detail:'Your notes have been saved.' });

    }, error => {
    })
  }

  addMs = (date: Date, ms: number): Date => {
    const result = new Date(date);
    result.setMilliseconds(result.getMilliseconds() + ms);
    return result;
  };

  calculateChildAge(dateOfBirth: Date): number {
    if (!dateOfBirth) {
      return 0;
    }
    
    const today = new Date();
    const birthDate = new Date(dateOfBirth);
    
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
    
    // Adjust age if birthday hasn't occurred this year
    if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    
    return age;
  }

  subscribe()
  {
    this.router.navigateByUrl("/subscriptions");
  }

  reprintConfirmation(){

  }
  //---------------------------------------------------------------------------------------
  //Dynamic text on the booking email
  //
  //A template can carry {{DYNAMICTEXT}} placeholders. Picking a template pulls back an
  //example of it, counts the placeholders, and offers a box for each so staff can fill them
  //in before sending. The same pattern the Booking Block and Events screens use.
  //---------------------------------------------------------------------------------------

  ExampleEmail: string = "";
  EmailContainsDynamicText: boolean = false;
  DynamicContentButton: string = "";
  ShowDynamicTextEditor: boolean = false;
  dynamicTextArray: any[] = [];
  MasterCopy: string = "";
  EmailSubject: string = "";
  EmailText: string = "";
  backUpText: string = "";

  getNumberOfDynamicElements(InString, InWord)
  {
    let count = 0;
    let position = InString.indexOf(InWord);

    while (position !== -1) {
      count++;
      position = InString.indexOf(InWord, position + 1);
    }

    return count;
  }

  changeTemplate()
  {
    this.ShowDynamicTextEditor = false;
    this.EmailContainsDynamicText = false;
    this.DynamicContentButton = "";
    this.dynamicTextArray = [];
    this.ExampleEmail = "";

    if (this.selectedEmailTemplate == null) {
      return;
    }

    this.http.get(bmxurl + "/emailtemplateexample/" + this.VenueID + "/" + this.selectedEmailTemplate.emailtemplateid).subscribe(response => {
      this.httpResponse = response;

      if(this.httpResponse.succeeded)
      {
        this.ExampleEmail = (response as any).data;

        this.backUpText = this.ExampleEmail;
        this.MasterCopy = this.ExampleEmail;

        this.EmailSubject = this.selectedEmailTemplate.emailsubject;

        let i = this.getNumberOfDynamicElements(this.ExampleEmail, "{{DYNAMICTEXT}}");

        if(i > 0)
        {
          this.DynamicContentButton = i == 1
            ? "You have a dynamic text area, please fill it in below."
            : "You have " + i + " dynamic text areas, please fill them in below.";

          this.EmailContainsDynamicText = true;

          //index is zero based because that is what the API expects. The screen adds one
          //when it labels the boxes, so staff still see "Dynamic Text 1" first.
          let indexid = 0;

          for(let x = 0; x < i; x++)
          {
            this.dynamicTextArray.push({text: "", index: indexid});
            indexid++;
          }

          this.ShowDynamicTextEditor = true;
        }
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail: 'Could not load an example of that template.'});
    });
  }

  SaveText(){
    this.ExampleEmail = this.backUpText;

    this.dynamicTextArray.forEach(element => {
      this.ExampleEmail = this.ExampleEmail.replace("{{DYNAMICTEXT}}", element.text);
    });

    this.EmailText = this.ExampleEmail;

    this.messageService.add({severity:'success', summary:'Updated', detail:'Preview updated. Press Send when you are happy with it.'});
  }

  CancelText()
  {
    this.dynamicTextArray.forEach((element: any) => {
      element.text = "";
    });

    this.ExampleEmail = this.MasterCopy;
    this.backUpText = this.MasterCopy;
  }
}

enum Sections {
  Date = 0,
  Package = 1,
  Admissions = 2,
  Partyroom = 3,
  Time = 4,
  Customer = 5,
  Extras = 6,
  Notes = 7,
  Payment = 8,
}


